/* Stage Shop — size chart unit toggle */
(function () {

  function toIn(cm) {
    return Math.round(parseFloat(cm) / 2.54);
  }

  document.addEventListener('change', function (e) {
    if (e.target.type !== 'checkbox') return;

    var root = e.target.closest('[data-size-chart]');
    if (!root) return;

    var isCm  = e.target.checked;
    var table = root.querySelector('table');
    if (!table) return;

    root.querySelectorAll('.sc-unit-lbl').forEach(function (lbl) {
      var isIn = lbl.textContent.trim() === 'IN';
      lbl.classList.toggle('sc-unit-lbl--on', isCm ? !isIn : isIn);
    });

    table.querySelectorAll('.sc-unit').forEach(function (el) {
      el.textContent = isCm ? '(cm)' : '(in)';
    });

    table.querySelectorAll('.mv').forEach(function (cell) {
      var lo = cell.getAttribute('data-lo');
      var hi = cell.getAttribute('data-hi');
      cell.textContent = isCm
        ? lo + '\u2013' + hi
        : toIn(lo) + '\u2013' + toIn(hi);
    });
  });

}());

/* ==========================================================================
   sc-lookup — generic two-axis lookup chart finder
   Reads any .sc-lookup__grid table and builds a slider finder from it.
   No chart-specific data lives here.
   Handles charts injected after load (Impulse tooltips, drawers, quick view).
   ========================================================================== */
(function (window, document) {
  'use strict';

  var DEFAULTS = {
    finderTitle: 'Find my {noun}',
    noun: 'size',
    nounPlural: null,                  // defaults to noun + 's'
    betweenMarkers: ['•', '·', '●', '*', '-', '–', '—'],
    largerNeighbour: 'last',           // 'last' = right/lower cell is the larger value
    copy: {
      singleLead: 'Your {noun}',
      betweenLead: 'Between {nounPlural}',
      emptyLead: 'Result',
      emptyValue: 'No {noun}',
      betweenNote: 'You sit between these two {nounPlural}. We suggest {larger}, the larger of the two.',
      emptyNote: 'This combination sits outside the available range. Get in touch and we\'ll help you find an alternative.',
      hint: 'Sliders step through the increments used in the chart below.'
    }
  };

  /* ---------- helpers ---------- */

  function textOf(el) {
    return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var src = arguments[i];
      if (!src) continue;
      for (var k in src) {
        if (!Object.prototype.hasOwnProperty.call(src, k)) continue;
        if (src[k] && typeof src[k] === 'object' && !(src[k] instanceof Array)) {
          target[k] = assign({}, target[k] || {}, src[k]);
        } else {
          target[k] = src[k];
        }
      }
    }
    return target;
  }

  function fill(str, vars) {
    return String(str).replace(/\{(\w+)\}/g, function (m, key) {
      return vars[key] != null ? vars[key] : m;
    });
  }

  // "Weight (kg)" -> { label: 'Weight', unit: 'kg' }
  function splitAxis(str) {
    var m = str.match(/^(.*?)\s*\(([^)]*)\)\s*$/);
    return m ? { label: m[1].trim(), unit: m[2].trim() } : { label: str, unit: '' };
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  /* ---------- table -> model ---------- */

  function classifyCell(cell, markers) {
    if (!cell) return { kind: 'empty' };
    var cls = cell.className || '';
    if (/(^|\s)(sc-lookup__btw|is-between)(\s|$)/.test(cls)) return { kind: 'between' };
    if (/(^|\s)(sc-lookup__na|is-empty)(\s|$)/.test(cls)) return { kind: 'empty' };
    var t = textOf(cell);
    if (!t) return { kind: 'empty' };
    if (markers.indexOf(t) !== -1) return { kind: 'between' };
    return { kind: 'value', value: t };
  }

  function buildModel(table, opts) {
    var head = table.tHead;
    var body = table.tBodies[0];
    if (!head || !body || !head.rows.length || !body.rows.length) return null;

    var axisRow = head.rows[head.rows.length - 1];
    if (axisRow.cells.length < 3) return null;

    // Column axis name: any spanning header cell above the axis row.
    var colAxisText = '';
    for (var r = 0; r < head.rows.length - 1 && !colAxisText; r++) {
      var cells = head.rows[r].cells;
      for (var c = 0; c < cells.length; c++) {
        if ((cells[c].colSpan || 1) > 1) { colAxisText = textOf(cells[c]); break; }
      }
    }

    var cols = [];
    for (var i = 1; i < axisRow.cells.length; i++) cols.push(textOf(axisRow.cells[i]));

    var rows = [], grid = [];
    for (var j = 0; j < body.rows.length; j++) {
      var tr = body.rows[j];
      if (!tr.cells.length) continue;
      rows.push(textOf(tr.cells[0]));
      var line = [];
      for (var k = 0; k < cols.length; k++) {
        line.push(classifyCell(tr.cells[k + 1], opts.betweenMarkers));
      }
      grid.push(line);
    }

    if (rows.length < 2 || cols.length < 2) return null;

    return {
      rowAxis: splitAxis(textOf(axisRow.cells[0])),
      colAxis: splitAxis(colAxisText || 'Value'),
      rows: rows,
      cols: cols,
      grid: grid
    };
  }

  /* ---------- lookup ---------- */

  function pairFrom(a, b, largerNeighbour) {
    return largerNeighbour === 'first'
      ? { smaller: b, larger: a }
      : { smaller: a, larger: b };
  }

  function resolve(model, r, c, opts) {
    var cell = model.grid[r][c];
    if (cell.kind === 'value') return { type: 'value', value: cell.value };
    if (cell.kind === 'empty') return { type: 'empty' };

    var line = model.grid[r];
    var left = c > 0 ? line[c - 1] : null;
    var right = c < model.cols.length - 1 ? line[c + 1] : null;
    if (left && left.kind === 'value' && right && right.kind === 'value') {
      return assign({ type: 'between' }, pairFrom(left.value, right.value, opts.largerNeighbour));
    }

    var up = r > 0 ? model.grid[r - 1][c] : null;
    var down = r < model.rows.length - 1 ? model.grid[r + 1][c] : null;
    if (up && up.kind === 'value' && down && down.kind === 'value') {
      return assign({ type: 'between' }, pairFrom(up.value, down.value, opts.largerNeighbour));
    }

    // Boundary cell with only one neighbour on the chart.
    var sides = [left, right, up, down];
    for (var i = 0; i < sides.length; i++) {
      if (sides[i] && sides[i].kind === 'value') return { type: 'value', value: sides[i].value };
    }
    return { type: 'empty' };
  }

  /* ---------- UI ---------- */

  function buildControl(axis, values, startIndex) {
    var wrap = el('div', 'sc-lookup__control');
    var label = el('label', 'sc-lookup__label');
    var name = el('span', null, axis.label);
    var out = el('span', 'sc-lookup__val');
    var input = document.createElement('input');

    input.type = 'range';
    input.className = 'sc-lookup__range';
    input.min = '0';
    input.max = String(values.length - 1);
    input.step = '1';
    input.value = String(startIndex);
    input.setAttribute('aria-label', axis.label);

    label.appendChild(name);
    label.appendChild(out);
    wrap.appendChild(label);
    wrap.appendChild(input);

    return {
      node: wrap,
      input: input,
      render: function (idx) {
        var v = values[idx];
        out.textContent = axis.unit ? v + ' ' + axis.unit : v;
        input.setAttribute('aria-valuetext', out.textContent);
      }
    };
  }

  function init(root) {
    // Guard on a JS property, not a class. Themes that clone this markup via
    // innerHTML (Impulse's tool-tip-trigger does) would copy a class and
    // permanently block the visible copy, whose listeners are gone.
    if (root.scLookupBound) return;

    var table = root.querySelector('.sc-lookup__grid');
    if (!table) return;

    // Drop any finder carried in from a clone so it gets live listeners.
    var stale = root.querySelector('.sc-lookup__finder');
    if (stale && stale.parentNode) stale.parentNode.removeChild(stale);

    var opts = assign({}, DEFAULTS, window.ScLookup && window.ScLookup.options);
    opts.nounPlural = opts.nounPlural || opts.noun + 's';

    var model = buildModel(table, opts);
    if (!model) return;

    var vars = { noun: opts.noun, nounPlural: opts.nounPlural };

    var finder = el('div', 'sc-lookup__finder');
    finder.appendChild(el('p', 'sc-lookup__finder-title', fill(opts.finderTitle, vars)));

    var controls = el('div', 'sc-lookup__controls');
    var rowStart = Math.floor(model.rows.length / 2);
    var colStart = Math.floor(model.cols.length / 2);
    var rowCtl = buildControl(model.rowAxis, model.rows, rowStart);
    var colCtl = buildControl(model.colAxis, model.cols, colStart);
    controls.appendChild(rowCtl.node);
    controls.appendChild(colCtl.node);
    finder.appendChild(controls);

    var result = el('div', 'sc-lookup__result');
    result.setAttribute('role', 'status');
    result.setAttribute('aria-live', 'polite');
    finder.appendChild(result);

    if (opts.copy.hint) finder.appendChild(el('p', 'sc-lookup__hint', opts.copy.hint));

    var scroll = root.querySelector('.sc-lookup__scroll') || table;
    scroll.parentNode.insertBefore(finder, scroll);

    var body = table.tBodies[0];
    var headAxisRow = table.tHead.rows[table.tHead.rows.length - 1];

    function highlight(r, c) {
      var marked = table.querySelectorAll('.is-lookup-hit, .is-lookup-axis');
      for (var i = 0; i < marked.length; i++) {
        marked[i].classList.remove('is-lookup-hit', 'is-lookup-axis');
      }

      var tr = body.rows[r];
      if (!tr) return;
      if (tr.cells[c + 1]) tr.cells[c + 1].classList.add('is-lookup-hit');
      if (tr.cells[0]) tr.cells[0].classList.add('is-lookup-axis');
      if (headAxisRow.cells[c + 1]) headAxisRow.cells[c + 1].classList.add('is-lookup-axis');
    }

    function render() {
      var r = parseInt(rowCtl.input.value, 10);
      var c = parseInt(colCtl.input.value, 10);
      rowCtl.render(r);
      colCtl.render(c);

      var res = resolve(model, r, c, opts);
      var lead, value, note = '';

      if (res.type === 'value') {
        lead = fill(opts.copy.singleLead, vars);
        value = res.value;
        result.classList.remove('sc-lookup__result--empty');
      } else if (res.type === 'between') {
        lead = fill(opts.copy.betweenLead, vars);
        value = res.smaller + ' / ' + res.larger;
        note = fill(opts.copy.betweenNote, assign({}, vars, { larger: res.larger, smaller: res.smaller }));
        result.classList.remove('sc-lookup__result--empty');
      } else {
        lead = fill(opts.copy.emptyLead, vars);
        value = fill(opts.copy.emptyValue, vars);
        note = fill(opts.copy.emptyNote, vars);
        result.classList.add('sc-lookup__result--empty');
      }

      result.innerHTML = '';
      result.appendChild(el('p', 'sc-lookup__result-lead', lead));
      result.appendChild(el('p', 'sc-lookup__result-value', value));
      if (note) result.appendChild(el('p', 'sc-lookup__result-note', note));

      highlight(r, c);
    }

    rowCtl.input.addEventListener('input', render);
    colCtl.input.addEventListener('input', render);

    root.scLookupBound = true;
    root.classList.add('is-ready');
    render();
  }

  function refresh(scope) {
    var roots = (scope || document).querySelectorAll('.sc-lookup');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  /* Catch charts injected after load: Impulse size chart tooltips, drawers,
     quick view. The nodes we add are never .sc-lookup, so this can't loop. */
  function observe() {
    if (!window.MutationObserver || !document.body) return;
    var queued = false;

    function schedule() {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; refresh(); }, 0);
    }

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if ((n.classList && n.classList.contains('sc-lookup')) ||
              (n.querySelector && n.querySelector('.sc-lookup'))) {
            schedule();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.ScLookup = assign({ options: {} }, window.ScLookup, { refresh: refresh, init: init });

  function boot() { refresh(); observe(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(window, document);

/* Open studio hire in new tab */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.site-nav__dropdown a[href*="studio50"]').forEach(function (link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  });
}());


/* ==========================================================================
   Stage Shop — delivery estimate, calculation core
   Build spec section 6. Pure: no DOM access, no fetch, no timers in here.
   Config and the static dataset are injected by the bootstrap block, so this
   whole section can be lifted out and unit tested with time frozen.

   Everything below is delimited by the CORE markers for the test harness.
   Do not remove them.
   ========================================================================== */
/* TSS-DELIVERY-CORE-START */
(function (window) {
  'use strict';

  /* Dispatch origin. Adelaide, so the dispatch leg uses the SA calendar
     while the transit leg uses the destination's. */
  var ORIGIN_STATE = 'SA';

  /* Pickup is a display method like the other two, but it has no
     destination: the customer collects from the shop. */
  var METHODS = ['parcel', 'express', 'pickup'];

  var config = null;
  var staticData = null;

  var warnedExpired = false;
  var debuggedVendors = {};
  var listeners = [];

  var readyResolve;
  var ready = new Promise(function (res) { readyResolve = res; });

  var DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
             'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* ---------- civil dates -------------------------------------------------
     A civil date is {y, m, d} with m 1-12. All business day arithmetic runs
     on these plain parts rather than on UTC timestamps, so a daylight saving
     boundary can never shift a result by a day. */

  function civil(y, m, d) { return { y: y, m: m, d: d }; }
  function civilToMs(c) { return Date.UTC(c.y, c.m - 1, c.d); }
  function msToCivil(ms) {
    var dt = new Date(ms);
    return civil(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate());
  }
  function addDays(c, n) { return msToCivil(civilToMs(c) + n * 86400000); }
  function dayOfWeek(c) { return new Date(civilToMs(c)).getUTCDay(); }
  function pad2(n) { return n < 10 ? '0' + n : '' + n; }
  function isoDate(c) { return c.y + '-' + pad2(c.m) + '-' + pad2(c.d); }

  /* Dates handed back to callers are UTC midnight of the civil date, so the
     viewer's own timezone cannot shift the day. Read them with getUTC*. */
  function toDate(c) { return new Date(civilToMs(c)); }

  /* ---------- timezone ----------------------------------------------------
     Offsets are derived from Intl, never hardcoded, so ACST/ACDT is handled
     without the module knowing daylight saving exists. */

  var partsFmt = null;
  var partsFmtTz = null;

  function timezone() {
    return (config && config.timezone) || 'Australia/Adelaide';
  }

  function zoneParts(date) {
    var tz = timezone();
    if (!partsFmt || partsFmtTz !== tz) {
      partsFmt = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz, hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
      partsFmtTz = tz;
    }
    var parts = partsFmt.formatToParts(date);
    var out = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type !== 'literal') out[parts[i].type] = parseInt(parts[i].value, 10);
    }
    if (out.hour === 24) out.hour = 0;
    return out;
  }

  /* Milliseconds to add to a UTC timestamp to get the same wall clock in tz.
     Whole seconds are compared on both sides so sub-second drift cannot leak
     into the offset. */
  function zoneOffsetMs(date) {
    var p = zoneParts(date);
    var wall = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    return wall - Math.floor(date.getTime() / 1000) * 1000;
  }

  /* ---------- holidays ---------------------------------------------------- */

  function holidaysUsable(todayIso) {
    if (!staticData || !staticData.holidays) return false;
    var validTo = staticData.holidaysValidTo;
    if (!validTo || todayIso > validTo) {
      if (!warnedExpired) {
        warnedExpired = true;
        if (window.console && console.warn) {
          console.warn('TSS delivery: holiday data expired (file version '
            + ((staticData && staticData.version) || 'unknown')
            + ', valid to ' + (validTo || 'unset')
            + '). Falling back to weekends only.');
        }
      }
      return false;
    }
    return true;
  }

  function isHoliday(c, state) {
    var iso = isoDate(c);
    var h = staticData.holidays || {};
    if (h.NAT && h.NAT.indexOf(iso) !== -1) return true;
    if (h[state] && h[state].indexOf(iso) !== -1) return true;
    return false;
  }

  /* ---------- business days (spec 6.2) ------------------------------------ */

  function isBusinessDay(c, state, useHolidays) {
    var dow = dayOfWeek(c);
    if (dow === 0 || dow === 6) return false;
    if (!useHolidays) return true;
    return !isHoliday(c, state);
  }

  function nextBusinessDay(c, state, useHolidays) {
    do { c = addDays(c, 1); } while (!isBusinessDay(c, state, useHolidays));
    return c;
  }

  function addBusinessDays(c, n, state, useHolidays) {
    while (!isBusinessDay(c, state, useHolidays)) c = nextBusinessDay(c, state, useHolidays);
    for (var i = 0; i < n; i++) c = nextBusinessDay(c, state, useHolidays);
    return c;
  }

  /* ---------- postcode lookup --------------------------------------------- */

  function lookupPostcode(pc) {
    if (!staticData || !staticData.postcodes) return null;
    var s = String(pc == null ? '' : pc);
    if (!/^\d{4}$/.test(s)) return null;
    var n = parseInt(s, 10);
    var a = staticData.postcodes, lo = 0, hi = a.length - 1;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      if (n < a[mid][0]) hi = mid - 1;
      else if (n > a[mid][1]) lo = mid + 1;
      else return a[mid][2];
    }
    return null;
  }

  /* A postcode resolving to a region code with no metaobject entry is a
     no_region failure, not a crash. */
  function regionFor(pc) {
    var code = lookupPostcode(pc);
    if (!code) return null;
    var r = config && config.regions && config.regions[code];
    if (!r || !r.state || !r.parcel || !r.express) return null;
    return { code: code, state: r.state, parcel: r.parcel, express: r.express };
  }

  /* ---------- lead time resolution (spec 5.3 precedence) ------------------ */

  function isBackordered(line) {
    /* inventory_management guards untracked variants, which report quantity 0
       while being freely sellable. variant.available is never a stock check:
       it is true for backordered lines.

       The stock test is against how many are wanted, not against zero. One
       left on the shelf and three in the basket means two have to be ordered
       in, and the customer needs telling. With the default quantity of one
       this is exactly the old "quantity <= 0" test. */
    if (!line) return false;
    var wanted = line.quantity == null ? 1 : line.quantity;
    return line.inventoryManagement === 'shopify'
      && line.inventoryPolicy === 'continue'
      && line.inventoryQuantity < wanted;
  }

  /* Lead time is a range, [fewest, most] business days from order placed to
     us being able to dispatch. Returns null when it is genuinely unknown,
     which is state C. A single number from any source widens to [n, n]. */
  function pair(lo, hi) {
    if (lo == null) return null;
    if (hi == null || hi < lo) hi = lo;
    return [lo, hi];
  }

  function resolveLeadDays(vendor, metafieldDays) {
    /* The product override is a single number, so it pins both ends. */
    if (metafieldDays != null && metafieldDays >= 0) return pair(metafieldDays, metafieldDays);

    var table = (config && config.vendorLeadDays) || {};
    if (vendor && Object.prototype.hasOwnProperty.call(table, vendor)) {
      var entry = table[vendor];
      /* Array.isArray, not instanceof: the config object can come from a
         different JavaScript realm and instanceof silently fails there. */
      if (Array.isArray(entry)) return pair(entry[0], entry[1]);
      return pair(entry, entry);
    }

    var lo = config && config.defaultVendorLeadDays;
    var hi = config && config.defaultVendorLeadDaysMax;
    if (lo != null && lo > 0) {
      var key = vendor || '(no vendor)';
      if (!debuggedVendors[key]) {
        debuggedVendors[key] = true;
        if (window.console && console.debug) {
          console.debug('TSS delivery: no lead time for vendor "' + key
            + '", using the default of ' + lo + ' to ' + (hi == null || hi < lo ? lo : hi)
            + ' business days. Add a Vendor Lead Time entry to replace it.');
        }
      }
      return pair(lo, hi);
    }
    return null; /* state C */
  }

  function lineLeadDays(line) {
    if (!isBackordered(line)) return [0, 0];
    return resolveLeadDays(line.vendor, line.metafieldDays);
  }

  /* One range per cart, driven by the slowest line at each end. A single
     unknown line makes the whole cart unknown rather than quoting an
     optimistic date from the rest. */
  function cartLeadDays(lines) {
    if (!lines || !lines.length) return [0, 0];
    var lo = 0, hi = 0;
    for (var i = 0; i < lines.length; i++) {
      var lead = lineLeadDays(lines[i]);
      if (lead == null) return null;
      if (lead[0] > lo) lo = lead[0];
      if (lead[1] > hi) hi = lead[1];
    }
    return [lo, hi];
  }

  /* ---------- the estimate (spec 6.3) ------------------------------------- */

  function fail(reason) {
    return { ok: false, reason: reason, dispatch: null, min: null, max: null, msToCutoff: null };
  }

  function estimate(opts) {
    opts = opts || {};
    var now = opts.now || new Date();
    var method = METHODS.indexOf(opts.method) !== -1 ? opts.method : 'parcel';

    if (!config || config.enabled === false) return fail('disabled');
    if (!staticData) return fail('no_data');

    var p = zoneParts(now);
    var today = civil(p.year, p.month, p.day);
    var useHolidays = holidaysUsable(isoDate(today));

    /* Pickup is collected from the Adelaide shop, so there is no destination
       and no transit. It must not fail on a postcode it never needed. */
    var isPickup = method === 'pickup';
    var region = isPickup ? null : regionFor(opts.postcode);
    if (!isPickup && !region) return fail('no_region');

    /* leadDays as a single number is accepted as shorthand for [n, n]. */
    var lead = opts.leadMin != null ? pair(opts.leadMin, opts.leadMax)
             : (Array.isArray(opts.leadDays) ? pair(opts.leadDays[0], opts.leadDays[1])
             : (opts.leadDays != null ? pair(opts.leadDays, opts.leadDays) : null));
    if (lead == null) return fail('unknown_lead');

    var cutoffHour = (config.cutoffHour == null) ? 12 : config.cutoffHour;
    var buffer = config.dispatchBufferDays || 0;

    var start = today;
    if (!isBusinessDay(start, ORIGIN_STATE, useHolidays) || p.hour >= cutoffHour) {
      start = nextBusinessDay(start, ORIGIN_STATE, useHolidays);
    }

    /* Both ends of the lead range travel through the dispatch leg, so a
       vendor quoted 2 to 4 days widens the customer's date range rather than
       pretending to a precision we do not have. */
    var dispatchMin = addBusinessDays(start, lead[0] + buffer, ORIGIN_STATE, useHolidays);
    var dispatchMax = addBusinessDays(start, lead[1] + buffer, ORIGIN_STATE, useHolidays);

    var band = isPickup ? [0, 0] : region[method];
    var transitState = isPickup ? ORIGIN_STATE : region.state;
    var min = addBusinessDays(dispatchMin, band[0], transitState, useHolidays);
    var max = addBusinessDays(dispatchMax, band[1], transitState, useHolidays);

    /* Countdown. This condition deliberately references neither leadDays nor
       dispatchBufferDays: step 4 rolls the start past the cutoff before the
       lead time is added, so beating 12pm pulls a backordered order forward
       by a full business day too. Gating it on stock would be wrong, and
       letting the buffer leak in would silently kill it everywhere.

       It counts down to the next cutoff, which is later today if one is still
       coming, otherwise the next business day's. It only shows once that
       cutoff is inside the display window, which opens at countdownFromHour
       the evening before. Across a weekend or a holiday the next cutoff is
       further away than the window, so nothing shows. */
    var fromHour = (config.countdownFromHour == null) ? 17 : config.countdownFromHour;
    var windowMs = ((24 - fromHour) + cutoffHour) * 3600000;

    var cutoffDay = today;
    if (!isBusinessDay(today, ORIGIN_STATE, useHolidays) || p.hour >= cutoffHour) {
      cutoffDay = nextBusinessDay(today, ORIGIN_STATE, useHolidays);
    }
    var cutoffAt = Date.UTC(cutoffDay.y, cutoffDay.m - 1, cutoffDay.d, cutoffHour, 0, 0) - zoneOffsetMs(now);
    var remaining = cutoffAt - now.getTime();

    var msToCutoff = null;
    if (remaining > 0 && remaining <= windowMs) msToCutoff = remaining;

    return {
      ok: true,
      reason: null,
      dispatch: toDate(dispatchMin),
      dispatchMax: toDate(dispatchMax),
      min: toDate(min),
      max: toDate(max),
      msToCutoff: msToCutoff,
      leadDays: lead,
      region: region ? region.code : null,
      state: transitState,
      method: method
    };
  }

  /* ---------- formatting (spec 6.5) --------------------------------------- */

  function dayAndNum(d) { return DOW[d.getUTCDay()] + ' ' + d.getUTCDate(); }

  function format(min, max) {
    if (!min) return '';
    if (!max || min.getTime() === max.getTime()) {
      return dayAndNum(min) + ' ' + MON[min.getUTCMonth()];
    }
    if (min.getUTCMonth() === max.getUTCMonth() && min.getUTCFullYear() === max.getUTCFullYear()) {
      return dayAndNum(min) + ' to ' + dayAndNum(max) + ' ' + MON[max.getUTCMonth()];
    }
    return dayAndNum(min) + ' ' + MON[min.getUTCMonth()]
         + ' to ' + dayAndNum(max) + ' ' + MON[max.getUTCMonth()];
  }

  /* Formats whatever it is handed. Whether a countdown should be shown at all
     is decided in estimate(), by the display window, so that widening that
     window in settings is not silently undone by a hardcoded cap here. */
  function formatCountdown(ms) {
    if (ms == null || ms <= 0) return '';
    var total = Math.floor(ms / 1000);
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    if (h >= 1) return h + 'h ' + m + 'm';
    if (ms < 5 * 60000) return m + 'm ' + s + 's';
    return m + 'm';
  }

  /* ---------- postcode and method preference ------------------------------ */

  var PC_KEY = 'tss_pc';
  var METHOD_KEY = 'tss_ship_method';
  var memory = {};

  function store(key, value) {
    memory[key] = value;
    try { window.localStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }

  function read(key) {
    try {
      var v = window.localStorage.getItem(key);
      if (v != null) return v;
    } catch (e) { /* private mode */ }
    return memory[key] != null ? memory[key] : null;
  }

  function validPostcode(pc) { return /^\d{4}$/.test(String(pc == null ? '' : pc)); }

  function getPostcode() {
    var pc = read(PC_KEY);
    if (validPostcode(pc)) return pc;
    return (config && config.defaultPostcode) || '2000';
  }

  function setPostcode(pc) {
    var s = String(pc == null ? '' : pc).trim();
    if (!validPostcode(s)) return false;
    store(PC_KEY, s);
    emit();
    return true;
  }

  function getMethod() {
    var stored = read(METHOD_KEY);
    return METHODS.indexOf(stored) !== -1 ? stored : 'parcel';
  }

  function setMethod(m) {
    store(METHOD_KEY, METHODS.indexOf(m) !== -1 ? m : 'parcel');
    emit();
  }

  function onChange(cb) { if (typeof cb === 'function') listeners.push(cb); }

  function emit() {
    for (var i = 0; i < listeners.length; i++) {
      try { listeners[i](); } catch (e) { /* one bad listener must not stop the rest */ }
    }
  }

  /* ---------- wiring ------------------------------------------------------ */

  function configure(cfg, data) {
    config = cfg || null;
    staticData = data || null;
    warnedExpired = false;
    debuggedVendors = {};
    return !!(config && staticData);
  }

  window.TSSDelivery = {
    ready: ready,

    getPostcode: getPostcode,
    setPostcode: setPostcode,
    getMethod: getMethod,
    setMethod: setMethod,
    onChange: onChange,

    estimate: estimate,
    format: format,
    formatCountdown: formatCountdown,

    isBackordered: isBackordered,
    lineLeadDays: lineLeadDays,
    cartLeadDays: cartLeadDays,
    resolveLeadDays: resolveLeadDays,
    lookupPostcode: lookupPostcode,

    _configure: configure,
    _markReady: function () { readyResolve(); },
    _internals: {
      methods: METHODS,
      pair: pair,
      isBusinessDay: isBusinessDay,
      nextBusinessDay: nextBusinessDay,
      addBusinessDays: addBusinessDays,
      civil: civil,
      isoDate: isoDate,
      zoneParts: zoneParts
    }
  };
})(window);
/* TSS-DELIVERY-CORE-END */

/* ==========================================================================
   Stage Shop — delivery estimate, bootstrap and product page rendering
   Build spec sections 8 and 12. Everything that touches the DOM, the network
   or timers lives here; the calculation core above stays pure.
   ========================================================================== */
/* TSS-DELIVERY-PDP-START */
(function (window, document) {
  'use strict';

  var D = window.TSSDelivery;
  if (!D) return;

  var CONFIG_ID = 'tss-delivery-config';
  var CACHE_KEY = 'tss_delivery_static';

  /* ---------- config and data --------------------------------------------
     A missing or unparseable config tag means "do not render". The Liquid
     side emits nothing when the kill switch is off or when no usable region
     exists, so both degradation cases arrive here as an absent tag. */

  function readConfig() {
    var el = document.getElementById(CONFIG_ID);
    if (!el) return null;
    try {
      var cfg = JSON.parse(el.textContent);
      if (!cfg || cfg.enabled === false) return null;
      if (!cfg.regions) return null;
      var any = false;
      for (var k in cfg.regions) { if (cfg.regions.hasOwnProperty(k)) { any = true; break; } }
      return any ? cfg : null;
    } catch (e) {
      return null;
    }
  }

  /* One request per session. The file is CDN cached and versioned by the
     asset URL, so the session cache is keyed on that URL: a new deploy
     changes the URL and invalidates the cache for free. */
  function loadStatic(url) {
    var cacheKey = CACHE_KEY;
    try {
      var raw = window.sessionStorage.getItem(cacheKey);
      if (raw) {
        var hit = JSON.parse(raw);
        if (hit && hit.url === url && hit.data) return Promise.resolve(hit.data);
      }
    } catch (e) { /* storage unavailable, fall through to fetch */ }

    return fetch(url, { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.postcodes || !data.holidays) throw new Error('malformed');
        try {
          window.sessionStorage.setItem(cacheKey, JSON.stringify({ url: url, data: data }));
        } catch (e) { /* quota or private mode, not fatal */ }
        return data;
      });
  }

  /* ---------- small DOM helpers ------------------------------------------ */

  function show(el, on) {
    if (!el) return;
    if (on) el.removeAttribute('hidden');
    else el.setAttribute('hidden', 'hidden');
  }

  function text(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function addClass(el, name) {
    if (!el) return;
    var names = (el.className || '').split(/\s+/).filter(Boolean);
    if (names.indexOf(name) === -1) { names.push(name); el.className = names.join(' '); }
  }

  function removeClass(el, name) {
    if (!el) return;
    var names = (el.className || '').split(/\s+/).filter(function (n) { return n && n !== name; });
    el.className = names.join(' ');
  }

  /* ---------- one product page module ------------------------------------ */

  function ProductModule(root) {
    this.root = root;
    this.statusEl = root.querySelector('[data-tss-status]');
    this.pcRow = root.querySelector('[data-tss-postcode-row]');
    this.pcValue = root.querySelector('[data-tss-postcode-value]');
    this.changeBtn = root.querySelector('[data-tss-change]');
    this.editRow = root.querySelector('[data-tss-edit]');
    this.input = root.querySelector('[data-tss-input]');
    this.toggle = root.querySelector('[data-tss-toggle]');
    this.estimateEl = root.querySelector('[data-tss-estimate]');
    this.estimateRow = root.querySelector('[data-tss-estimate-row]');
    this.countdownEl = root.querySelector('[data-tss-countdown]');
    this.errorEl = root.querySelector('[data-tss-error]');
    this.setBtn = root.querySelector('[data-tss-set]');
    this.tickEl = root.querySelector('[data-tss-tick]');
    this.statusTextEl = root.querySelector('[data-tss-status-text]');
    this.collectRow = root.querySelector('[data-tss-collect]');
    this.storeBtn = root.querySelector('[data-tss-store]');
    this.detail = root.querySelector('[data-tss-detail]');
    this.showEstimates = root.getAttribute('data-show-estimates') !== 'false';
    this.lastMethod = null;

    this.madeToOrder = root.getAttribute('data-made-to-order') === 'true';
    this.vendor = root.getAttribute('data-vendor') || '';
    this.defaultVariant = root.getAttribute('data-default-variant') === 'true';
    this.pickupEnabled = root.getAttribute('data-pickup-enabled') === 'true';
    this.readyHours = root.getAttribute('data-ready-hours') || '1-2';
    this.drawer = document.getElementById(root.getAttribute('data-drawer-id') || '');

    var mf = root.getAttribute('data-metafield-days');
    this.metafieldDays = (mf === null || mf === '') ? null : parseInt(mf, 10);

    this.variants = [];
    var json = root.querySelector('[data-tss-delivery-variants]');
    if (json) {
      try { this.variants = JSON.parse(json.textContent) || []; } catch (e) { this.variants = []; }
    }

    /* Server rendered the current variant's state; adopt it until the first
       variant:change tells us otherwise. */
    this.current = null;
    this.backordered = root.getAttribute('data-backordered') === 'true';
    this.available = !root.hasAttribute('hidden');
    /* Seed from the variant the server actually rendered, so the first paint
       and the first render agree. Guessing here would flash the wrong name. */
    this.variantTitle = '';
    var selected = parseInt(root.getAttribute('data-selected-variant'), 10);
    for (var vi = 0; vi < this.variants.length; vi++) {
      if (this.variants[vi].id === selected) { this.variantTitle = this.variants[vi].title || ''; break; }
    }

    this.timer = null;
    this.bind();
  }

  ProductModule.prototype.bind = function () {
    var self = this;

    if (this.changeBtn) {
      this.changeBtn.addEventListener('click', function () { self.openEditor(); });
    }

    if (this.input) {
      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); self.commit(); }
        else if (e.key === 'Escape') { e.preventDefault(); self.cancelEditor(); }
      });
      this.input.addEventListener('blur', function () { self.commit(); });
    }

    /* An explicit button, because on a phone it is not obvious that the way
       to apply a typed postcode is to press Enter or tap elsewhere. */
    if (this.setBtn) {
      this.setBtn.addEventListener('mousedown', function (e) { e.preventDefault(); });
      this.setBtn.addEventListener('click', function () { self.commit(); });
    }

    if (this.toggle) {
      this.toggle.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tss-method]');
        if (!btn) return;
        D.setMethod(btn.getAttribute('data-tss-method'));
      });
    }

    if (this.storeBtn && this.drawer) {
      this.storeBtn.addEventListener('click', function () { self.openDrawer(); });
      var closer = this.drawer.querySelector('[data-tss-drawer-close]');
      if (closer) closer.addEventListener('click', function () { self.closeDrawer(); });
      /* Clicking the backdrop closes it. The dialog element itself fills only
         the panel, so a click landing on the dialog box is a backdrop click. */
      this.drawer.addEventListener('click', function (e) {
        if (e.target === self.drawer) self.closeDrawer();
      });
    }

    /* An unavailable option combination fires variant:change with a null
       variant. The document level event cannot say which product it came
       from, so this listens on the owning product section instead, where the
       theme also dispatches it. */
    var section = this.root.closest('[data-section-type="product"]');
    if (section) {
      section.addEventListener('variantChange', function (e) {
        if (!(e.detail && e.detail.variant)) {
          self.available = false;
          self.render();
        }
      });
    }

    D.onChange(function () { self.render(); });
  };

  /* ---------- store details drawer ---------------------------------------- */

  ProductModule.prototype.openDrawer = function () {
    var drawer = this.drawer;
    if (!drawer) return;

    /* showModal gives focus trapping, Escape to close and an inert page for
       free, so none of that is hand written here. */
    if (typeof drawer.showModal === 'function') drawer.showModal();
    else drawer.setAttribute('open', 'open');

    /* The class goes on a frame later. A dialog goes from display none to
       block when it opens, and a transition cannot start on the same frame as
       that change, so setting it immediately would make the panel appear
       rather than slide. */
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { addClass(drawer, 'is-open'); });
      });
    } else {
      addClass(drawer, 'is-open');
    }
  };

  ProductModule.prototype.closeDrawer = function () {
    var drawer = this.drawer;
    if (!drawer) return;

    removeClass(drawer, 'is-open');

    /* Let the panel slide out before the dialog is actually closed, or it
       would vanish instantly. Matches the 0.45s panel transition. */
    var shut = function () {
      if (typeof drawer.close === 'function') { if (drawer.open) drawer.close(); }
      else drawer.removeAttribute('open');
    };
    if (window.setTimeout) window.setTimeout(shut, 450);
    else shut();
  };

  /* ---------- postcode editing (spec 8.4) --------------------------------- */

  ProductModule.prototype.openEditor = function () {
    if (!this.editRow || !this.input) return;
    this.previous = D.getPostcode();
    this.input.value = this.previous;
    show(this.pcRow, false);
    show(this.editRow, true);
    this.input.focus();
    this.input.select();
  };

  ProductModule.prototype.closeEditor = function () {
    show(this.editRow, false);
    show(this.errorEl, false);
    /* render decides whether the postcode row or the collect row belongs
       here, so it is not restored blindly. */
  };

  ProductModule.prototype.cancelEditor = function () {
    if (this.input) this.input.value = this.previous || D.getPostcode();
    this.closeEditor();
    this.render();
  };

  ProductModule.prototype.commit = function () {
    if (!this.input || !this.editRow || this.editRow.hasAttribute('hidden')) return;
    var value = this.input.value.trim();

    /* Validate before storing, never after. A postcode that is well formed
       but resolves to no region would otherwise be persisted, leaving a
       customer who mistyped stuck in state D on every future page view. */
    var valid = /^\d{4}$/.test(value) && D.lookupPostcode(value) !== null;

    if (!valid) {
      /* State D: the input stays open so it can be corrected in place, and
         the toggle and dates go away because there is nothing to show. */
      show(this.errorEl, true);
      show(this.estimateRow, false);
      this.stopCountdown();
      return;
    }

    D.setPostcode(value);
    this.closeEditor();
    this.render();
  };

  /* ---------- variant tracking (spec 8.5) --------------------------------- */

  ProductModule.prototype.ownsVariant = function (id) {
    for (var i = 0; i < this.variants.length; i++) {
      if (this.variants[i].id === id) return true;
    }
    return false;
  };

  ProductModule.prototype.setVariant = function (id) {
    for (var i = 0; i < this.variants.length; i++) {
      if (this.variants[i].id !== id) continue;
      var v = this.variants[i];
      this.current = v;
      this.variantTitle = v.title || '';
      this.backordered = D.isBackordered(v);
      /* available here is purchasability, not stock. A backordered variant
         is available and must keep rendering. */
      this.available = v.available !== false;
      break;
    }
    this.render();
  };

  /* ---------- rendering (spec 8.2, layout revised 20 Aug 2026) ------------ */

  ProductModule.prototype.leadDays = function () {
    if (!this.backordered) return [0, 0];
    return D.resolveLeadDays(this.vendor, this.metafieldDays);
  };

  /* The variant name leads the sentence whenever the product has variants, so
     the line reads as a fact about what the customer picked. */
  ProductModule.prototype.statusText = function () {
    var subject = (this.defaultVariant || !this.variantTitle) ? null : this.variantTitle;

    if (!this.backordered) {
      return subject ? subject + ' is in stock' : 'In stock';
    }
    if (this.madeToOrder) {
      return subject
        ? subject + " is made to order - we'll have it made for you"
        : "Made to order - we'll have it made for you";
    }
    return subject
      ? subject + " is not in stock - we'll order it in for you"
      : "Not in stock - we'll order it in for you";
  };

  /* Restarts the fade on the rows under the buttons. Removing the class and
     forcing a reflow before adding it back is what makes the animation replay
     on a repeat click rather than being ignored as an unchanged value. */
  ProductModule.prototype.swap = function () {
    var el = this.detail;
    if (!el) return;
    removeClass(el, 'is-swapping');
    if (el.offsetWidth !== undefined) { void el.offsetWidth; }
    addClass(el, 'is-swapping');
  };

  ProductModule.prototype.setNoDates = function (on) {
    var cls = 'tss-delivery--no-dates';
    var names = (this.root.className || '').split(/\s+/);
    var at = names.indexOf(cls);
    if (on && at === -1) names.push(cls);
    else if (!on && at !== -1) names.splice(at, 1);
    var next = names.join(' ').trim();
    if (next !== this.root.className) this.root.className = next;
  };

  ProductModule.prototype.render = function () {
    this.stopCountdown();

    /* State E. Not purchasable, so there is nothing to estimate. */
    show(this.root, this.available);
    if (!this.available) return;

    /* Status line: a tick and bold text in stock, plain text otherwise. */
    text(this.statusTextEl || this.statusEl, this.statusText());
    show(this.tickEl, !this.backordered);
    if (this.statusEl) {
      var inStockCls = 'tss-delivery__status--in-stock';
      var has = (this.statusEl.className || '').indexOf(inStockCls) !== -1;
      if (!this.backordered && !has) {
        this.statusEl.className = (this.statusEl.className + ' ' + inStockCls).trim();
      } else if (this.backordered && has) {
        this.statusEl.className = this.statusEl.className.split(/\s+/)
          .filter(function (c) { return c && c !== inStockCls; }).join(' ');
      }
    }

    /* Availability line only. Nothing below it can say anything useful when
       the product cannot be bought online. */
    if (!this.showEstimates) {
      show(this.toggle, false);
      show(this.detail, false);
      return;
    }
    show(this.detail, true);

    var method = D.getMethod();
    /* A stored pickup preference must not strand the customer on a product
       whose block has pickup switched off. */
    if (method === 'pickup' && !this.pickupEnabled) method = 'parcel';

    /* Only replay the fade when the customer actually switched method, not on
       every render: a countdown tick or a variant change should not flicker. */
    if (this.lastMethod !== null && this.lastMethod !== method) this.swap();
    this.lastMethod = method;

    var postcode = D.getPostcode();
    if (this.pcValue) text(this.pcValue, postcode);

    var buttons = this.toggle ? this.toggle.querySelectorAll('[data-tss-method]') : [];
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed',
        buttons[i].getAttribute('data-tss-method') === method ? 'true' : 'false');
    }

    var isPickup = method === 'pickup';
    var editing = this.editRow && !this.editRow.hasAttribute('hidden');

    var result = D.estimate({
      leadDays: this.leadDays(),
      postcode: postcode,
      method: method,
      now: new Date()
    });

    if (!result.ok) {
      /* C: no lead time, so there is no date to attach anything to, and
            nothing below the status line has anything to say.
         D: the postcode does not resolve, which is correctable in place. */
      var unknownLead = result.reason === 'unknown_lead';
      /* The toggle stays up in state D. Pickup needs no postcode, so leaving
         it reachable gives the customer a way out of a bad postcode rather
         than stranding them. */
      show(this.toggle, !unknownLead);
      show(this.pcRow, !unknownLead && !isPickup && !editing);
      show(this.collectRow, !unknownLead && isPickup);
      show(this.estimateRow, false);
      show(this.errorEl, result.reason === 'no_region' && editing);
      /* Only state C is a settled "no dates". State D keeps its space so
         entering a good postcode does not jump the page. */
      this.setNoDates(unknownLead);
      return;
    }

    this.setNoDates(false);
    show(this.errorEl, false);
    show(this.toggle, true);
    show(this.pcRow, !isPickup && !editing);
    show(this.collectRow, isPickup);
    show(this.estimateRow, true);
    this.paintEstimate(result, isPickup);
  };

  ProductModule.prototype.paintEstimate = function (result, isPickup) {
    var el = this.estimateEl;
    if (!el) return;

    /* Pickup, in stock: there is no date to give, only how soon it is ready.
       No countdown either, because beating the cutoff does not change it. */
    if (isPickup && !this.backordered) {
      text(this.countdownEl, '');
      show(this.countdownEl, false);
      text(el, 'Usually ready in ' + this.readyHours + ' business hours');
      return;
    }

    var range = D.format(result.min, result.max);
    var countdown = D.formatCountdown(result.msToCutoff);

    if (countdown && this.countdownEl) {
      /* The clock is a sibling of the live region, not a child of it, so a
         screen reader is never told the time once a second. They sit on one
         visual line because both are inline. */
      text(this.countdownEl, 'Order within ' + countdown);
      show(this.countdownEl, true);
      text(el, ' for ' + (isPickup ? 'estimated ready to collect ' : 'estimated delivery ') + range);
      this.startCountdown(result.msToCutoff);
    } else {
      text(this.countdownEl, '');
      show(this.countdownEl, false);
      text(el, (isPickup ? 'Estimated ready to collect ' : 'Estimated delivery ') + range);
    }
  };

  ProductModule.prototype.startCountdown = function (msRemaining) {
    var self = this;
    var deadline = Date.now() + msRemaining;

    this.timer = window.setInterval(function () {
      var remaining = deadline - Date.now();
      var next = remaining > 0 ? D.formatCountdown(remaining) : '';
      if (!next) {
        /* Re-run the whole estimate rather than hiding the block: the cutoff
           has passed, so the dates themselves have moved on a day. */
        self.stopCountdown();
        self.render();
        return;
      }
      text(self.countdownEl, 'Order within ' + next);
    }, 1000);
  };

  ProductModule.prototype.stopCountdown = function () {
    if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
  };

  /* ---------- cart drawer and cart page (spec 9) -------------------------- */

  function CartModule(root) {
    this.root = root;
    this.toggle = root.querySelector('[data-tss-toggle]');
    this.estimateEl = root.querySelector('[data-tss-estimate]');
    this.collectRow = root.querySelector('[data-tss-collect]');
    this.pickupEnabled = root.getAttribute('data-pickup-enabled') === 'true';
    this.readyHours = root.getAttribute('data-ready-hours') || '1-2';

    /* Scope to the owning cart form. The drawer markup is present on every
       page including /cart, so a document-wide query would count the page's
       lines and the drawer's together and double the cart. */
    this.scope = root.closest('form[data-location]') || document.body;

    this.bind();
  }

  CartModule.prototype.bind = function () {
    var self = this;

    if (this.toggle) {
      this.toggle.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-tss-method]');
        if (!btn) return;
        D.setMethod(btn.getAttribute('data-tss-method'));
      });
    }

    D.onChange(function () { self.render(); });

    /* Impulse replaces the contents of [data-products] wholesale after every
       cart change, and dispatches cart:updated before that replacement has
       landed. Watching the container is therefore more reliable than the
       event, and does not depend on Impulse's event names. */
    var products = this.scope.querySelector('[data-products]');
    if (products && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        window.setTimeout(function () { queued = false; self.render(); }, 0);
      }).observe(products, { childList: true, subtree: true });
    }
  };

  CartModule.prototype.lines = function () {
    var els = this.scope.querySelectorAll('[data-tss-qty]');
    var out = [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var lead = el.getAttribute('data-tss-lead');
      out.push({
        inventoryQuantity: parseInt(el.getAttribute('data-tss-qty'), 10) || 0,
        /* How many are wanted, so a line for three when one is on the shelf
           counts as needing ordering in. */
        quantity: parseInt(el.getAttribute('data-tss-want'), 10) || 1,
        inventoryPolicy: el.getAttribute('data-tss-policy') || '',
        inventoryManagement: el.getAttribute('data-tss-mgmt') || '',
        vendor: el.getAttribute('data-tss-vendor') || '',
        metafieldDays: (lead === null || lead === '') ? null : parseInt(lead, 10)
      });
    }
    return out;
  };

  CartModule.prototype.setNoDates = ProductModule.prototype.setNoDates;

  /* The prune pass in scan() stops any module's timers. Cart blocks never run
     one, so this is a no-op that keeps the two module types interchangeable. */
  CartModule.prototype.stopCountdown = function () {};

  /* The variant:change listener walks every module. A cart owns no variants,
     so answer false rather than throw and skip the modules queued behind it. */
  CartModule.prototype.ownsVariant = function () { return false; };
  CartModule.prototype.setVariant = function () {};

  CartModule.prototype.render = function () {
    var lines = this.lines();
    if (!lines.length) { show(this.root, false); return; }
    show(this.root, true);

    var method = D.getMethod();
    if (method === 'pickup' && !this.pickupEnabled) method = 'parcel';

    var buttons = this.toggle ? this.toggle.querySelectorAll('[data-tss-method]') : [];
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed',
        buttons[i].getAttribute('data-tss-method') === method ? 'true' : 'false');
    }

    var lead = D.cartLeadDays(lines);

    /* A single unknown line makes the whole cart unknown. Quoting a date from
       the remaining lines would be optimistic about the one thing the
       customer most needs to know. */
    if (lead == null) {
      this.setNoDates(true);
      show(this.toggle, false);
      show(this.collectRow, false);
      text(this.estimateEl, "Some items are being ordered in for you. We'll confirm your delivery date by email.");
      return;
    }

    var postcode = D.getPostcode();
    var result = D.estimate({ leadDays: lead, postcode: postcode, method: method, now: new Date() });

    if (!result.ok) {
      /* There is no postcode row in the cart to correct a bad postcode with,
         so there is nothing useful to say. Showing nothing beats showing a
         broken line. */
      show(this.root, false);
      return;
    }

    this.setNoDates(false);
    show(this.toggle, true);
    show(this.collectRow, method === 'pickup');

    var backordered = lead[1] > 0;
    var range = D.format(result.min, result.max);
    var sentence;

    if (method === 'pickup') {
      /* Collected from the shop, so there is no postcode in the sentence. */
      /* No ships-together line for pickup: the customer is collecting the
         whole order in one go, so there is nothing to say about it. */
      sentence = backordered
        ? 'Estimated ready to collect ' + range
        : 'Usually ready in ' + (this.readyHours || '1-2') + ' business hours';
    } else {
      sentence = 'Estimated delivery ' + range + ' to postcode ' + postcode;
      /* Only worth saying when there is more than one line to ship together.
         On a single line it states the obvious and reads as a warning. */
      if (backordered && lines.length > 1) {
        sentence = 'Ships together once everything is in. ' + sentence;
      }
    }

    /* No countdown here, in any state. */
    text(this.estimateEl, sentence);
  };

  /* ---------- boot -------------------------------------------------------- */

  var modules = [];

  function scan() {
    /* Drop modules whose markup has been torn out, so a Quick View opened
       and closed repeatedly cannot leave orphaned intervals ticking against
       detached nodes. */
    for (var k = modules.length - 1; k >= 0; k--) {
      if (!document.contains(modules[k].root)) {
        modules[k].stopCountdown();
        modules.splice(k, 1);
      }
    }

    var roots = document.querySelectorAll('[data-tss-delivery]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].tssDeliveryBound) continue;
      roots[i].tssDeliveryBound = true;
      var m = new ProductModule(roots[i]);
      modules.push(m);
      m.render();
    }

    var carts = document.querySelectorAll('[data-tss-cart]');
    for (var j = 0; j < carts.length; j++) {
      if (carts[j].tssDeliveryBound) continue;
      carts[j].tssDeliveryBound = true;
      var c = new CartModule(carts[j]);
      modules.push(c);
      c.render();
    }
  }

  function start() {
    var config = readConfig();
    if (!config) return; /* state F, nothing renders */

    loadStatic(config.staticUrl)
      .then(function (data) {
        if (!D._configure(config, data)) return;
        D._markReady();
        scan();
        observe();

        /* Seed the postcode from the cart attribute when local storage is
           empty, so a cleared browser with a surviving cart cookie keeps the
           customer's choice. Deliberately not awaited: the block paints with
           the default immediately, and setPostcode fires onChange, which
           repaints if the cart had something better. */
        seedFromCart();
      })
      .catch(function (e) {
        if (window.console && console.debug) {
          console.debug('TSS delivery: static data unavailable, module not rendered.', e);
        }
      });
  }

  function seedFromCart() {
    var stored = null;
    try { stored = window.localStorage.getItem('tss_pc'); } catch (e) { /* private mode */ }
    if (stored) return Promise.resolve();

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pc = cart && cart.attributes && cart.attributes['Delivery postcode'];
        /* Check it resolves, not just that it is four digits. The attribute is
           free text that could have been written by an older build or by hand,
           and an unresolvable value would put every surface into a failure
           state with no way to correct it from the cart. */
        if (pc && D.lookupPostcode(pc) !== null) D.setPostcode(pc);
      })
      .catch(function () { /* advisory only */ });
  }

  /* Quick View injects the product blocks after load, and Impulse re-renders
     the product section in the theme editor. Both arrive as new nodes. */
  function observe() {
    if (!window.MutationObserver || !document.body) return;
    var queued = false;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          var sel = '[data-tss-delivery], [data-tss-cart]';
          if ((n.matches && n.matches(sel)) ||
              (n.querySelector && n.querySelector(sel))) {
            if (queued) return;
            queued = true;
            window.setTimeout(function () { queued = false; scan(); }, 0);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Bind any block that has appeared since the last pass. Exposed because
     the cart surfaces re-render their markup wholesale, and because it lets
     the block be driven under test. Safe to call repeatedly: already-bound
     roots are skipped and detached ones are pruned. */
  D._scan = scan;

  /* Impulse dispatches this on the document for the product page and the
     Quick View popup alike. Each module only reacts to a variant it owns, so
     a change inside Quick View cannot rewrite the page behind it. */
  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    for (var i = 0; i < modules.length; i++) {
      /* A future module type without variant awareness must not break the
         modules queued behind it. */
      if (typeof modules[i].ownsVariant !== 'function') continue;
      if (modules[i].ownsVariant(variant.id)) modules[i].setVariant(variant.id);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(window, document);
/* TSS-DELIVERY-PDP-END */

/* ==========================================================================
   Stage Shop — availability line item property reconciliation
   Build spec section 10. This is the only code here that writes to a live
   cart, so every path is written to fail silently and leave the cart exactly
   as it was.

   The customer sees nothing from this block. No spinner, no toast, no error.
   If it cannot do its job the cart behaves exactly as it would have anyway.
   ========================================================================== */
/* TSS-DELIVERY-RECON-START */
(function (window, document) {
  'use strict';

  var D = window.TSSDelivery;
  if (!D) return;

  var PROP = 'Availability';
  var VALUE = 'Ordered in for you';

  /* Shopify cannot set a line's properties back to an empty object once one
     has been set, and removing the line is forbidden. When clearing the last
     remaining property, one private key is kept so the object stays non
     empty. Private keys are hidden in the cart, at checkout, in the
     confirmation email and on the packing slip. */
  var KEEP = '_tss_availability';

  var MAX_LINES = 20;
  var OP_TIMEOUT = 8000;

  var running = false;
  var lastSignature = null;
  var writesThisPass = 0;

  function noop() {}

  function debug(message, detail) {
    if (window.console && console.debug) console.debug('TSS delivery: ' + message, detail || '');
  }

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  /* ---------- the shared serial queue -------------------------------------
     The Cart API is not transactional, so two writes in flight at once lose
     data. Impulse writes to the cart too, from its quantity selectors, and
     has no queue of its own. Rather than run a second unguarded queue beside
     it, its cart methods are wrapped so every write in the theme passes
     through this one chain. The wrapper is applied from our own file and
     leaves Impulse's source untouched. */

  var tail = Promise.resolve();

  function enqueue(task) {
    var result = tail.then(task, task);
    /* A rejection must not poison the chain for everything queued after it. */
    tail = result.then(noop, noop);
    return result;
  }

  /* A stalled request must not block the queue forever, or a dropped
     connection would freeze the customer's quantity buttons. */
  function withTimeout(promise) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        debug('a cart write timed out, releasing the queue');
        resolve(null);
      }, OP_TIMEOUT);
      promise.then(function (value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(value);
      }, function (err) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve({ __error: err });
      });
    });
  }

  function wrapThemeCart() {
    var cart = window.theme && window.theme.cart;
    if (!cart || cart.tssQueued) return false;

    ['changeItem', 'updateAttribute', 'updateNote'].forEach(function (name) {
      var original = cart[name];
      if (typeof original !== 'function') return;
      cart[name] = function () {
        var args = arguments, self = this;
        return enqueue(function () { return original.apply(self, args); });
      };
    });

    cart.tssQueued = true;
    return true;
  }

  /* ---------- cart API ---------------------------------------------------- */

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js ' + res.status);
        return res.json();
      });
  }

  function postChange(body) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) {
        var err = new Error('cart change ' + res.status);
        err.status = res.status;
        throw err;
      }
      return res.json();
    });
  }

  /* ---------- postcode mirror to the cart attribute (spec 7) --------------
     localStorage is the source of truth on the device. This mirror is what
     carries the value onto the order and into the confirmation email, and it
     is what seedFromCart reads back when a browser's storage has been cleared
     but the cart cookie survived.

     The name is deliberately not underscore prefixed. A private attribute
     cannot be read from Liquid, so it could never render in the email. The
     trade is that it is visible to the customer at checkout. */

  var ATTR = 'Delivery postcode';
  var lastMirrored = null;

  function postUpdate(body) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) {
        var err = new Error('cart update ' + res.status);
        err.status = res.status;
        throw err;
      }
      return res.json();
    });
  }

  function mirrorPostcode() {
    if (designMode()) return Promise.resolve();

    var postcode = D.getPostcode();
    if (!postcode || postcode === lastMirrored) return Promise.resolve();

    return enqueue(function () {
      return withTimeout(getCart().then(function (cart) {
        /* Only mirror once a cart exists. Writing to an empty one would start
           a cart for a visitor who never added anything. */
        if (!cart || !cart.item_count) return null;

        var attrs = cart.attributes || {};
        if (attrs[ATTR] === postcode) { lastMirrored = postcode; return null; }

        /* Send the whole attribute set back with only our key changed. The
           ajax endpoint is documented as updating the keys you send, but
           merging explicitly costs nothing here and cannot clobber an
           attribute another app owns. Same discipline as the line properties. */
        var next = clone(attrs);
        next[ATTR] = postcode;

        return postUpdate({ attributes: next }).then(function () {
          lastMirrored = postcode;
        });
      }));
    }).then(function (result) {
      if (result && result.__error) debug('postcode not mirrored to the cart', result.__error);
    }, function (err) {
      /* Advisory only. The address entered at checkout is authoritative, which
         is why every customer-facing line says "estimated". */
      debug('postcode not mirrored to the cart', err);
    });
  }

  /* ---------- what the markup says ---------------------------------------
     Availability comes from the server rendered cart markup, not from extra
     product fetches, because the cart was rendered by Liquid moments ago and
     is therefore fresh. Keyed by variant, not by line key: a line key changes
     the moment its properties change, while backordered-ness is a fact about
     the variant and survives. */

  function desiredByVariant() {
    var out = {};
    var els = document.querySelectorAll('[data-tss-variant]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var id = parseInt(el.getAttribute('data-tss-variant'), 10);
      if (!id) continue;
      out[id] = D.isBackordered({
        inventoryQuantity: parseInt(el.getAttribute('data-tss-qty'), 10) || 0,
        quantity: parseInt(el.getAttribute('data-tss-want'), 10) || 1,
        inventoryPolicy: el.getAttribute('data-tss-policy') || '',
        inventoryManagement: el.getAttribute('data-tss-mgmt') || ''
      });
    }
    return out;
  }

  /* Cheap fingerprint of the rendered cart, so a drawer opened ten times with
     nothing changed costs nothing after the first pass. */
  function domSignature() {
    var els = document.querySelectorAll('[data-tss-variant]');
    var parts = [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      parts.push(
        (el.getAttribute('data-key') || '') + '|' +
        (el.getAttribute('data-tss-variant') || '') + '|' +
        (el.getAttribute('data-tss-qty') || '') + '|' +
        (el.getAttribute('data-tss-want') || '') + '|' +
        (el.getAttribute('data-tss-policy') || '') + '|' +
        (el.getAttribute('data-tss-mgmt') || '')
      );
    }
    return parts.join(',');
  }

  /* ---------- planning ---------------------------------------------------- */

  function clone(props) {
    var out = {};
    for (var k in props) {
      if (Object.prototype.hasOwnProperty.call(props, k)) out[k] = props[k];
    }
    return out;
  }

  function isEmpty(obj) {
    for (var k in obj) { if (Object.prototype.hasOwnProperty.call(obj, k)) return false; }
    return true;
  }

  /* Clone, change the one key we own, send the whole object back. Any app
     owned or private key we did not put there travels with it untouched:
     losing another app's property is worse than a stale message. */
  function nextProps(existing, add) {
    var next = clone(existing);
    if (add) {
      next[PROP] = VALUE;
      delete next[KEEP];
    } else {
      delete next[PROP];
      if (isEmpty(next)) next[KEEP] = '1';
    }
    return next;
  }

  function planFor(cart, desired) {
    var plan = [];
    if (!cart || !cart.items) return plan;

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      /* A product or variant deleted from the catalogue can leave a partial
         line, so guard at every step. */
      if (!item || !item.key || !item.variant_id) continue;

      var want = desired[item.variant_id];
      /* No markup for this variant means no fresh availability to act on.
         Leaving it alone is safer than guessing. */
      if (want === undefined) continue;

      var props = item.properties || {};
      var present = Object.prototype.hasOwnProperty.call(props, PROP);

      if (want && props[PROP] !== VALUE) plan.push({ key: item.key, add: true, props: props });
      else if (!want && present) plan.push({ key: item.key, add: false, props: props });
    }
    return plan;
  }

  /* One change at a time, re-planning from the cart the server just returned.
     That is what makes key changes and line merges safe: the next step is
     always computed from the current truth, never from a snapshot. */
  function applyPlan(cart, desired, budget) {
    var plan = planFor(cart, desired);
    if (!plan.length) return Promise.resolve(cart);

    if (budget <= 0) {
      if (window.console && console.warn) {
        console.warn('TSS delivery: more than ' + MAX_LINES +
          ' cart lines need an availability update. The rest will be picked up on the next cart render.');
      }
      return Promise.resolve(cart);
    }

    var step = plan[0];
    writesThisPass++;
    return postChange({ id: step.key, properties: nextProps(step.props, step.add) })
      .then(function (updated) {
        return applyPlan(updated, desired, budget - 1);
      });
  }

  /* ---------- the pass ---------------------------------------------------- */

  function pass() {
    /* Never mutate a cart inside the theme editor. */
    if (designMode()) return Promise.resolve();
    /* A pass can never start while a pass is running. */
    if (running) return Promise.resolve();

    var signature = domSignature();
    /* Empty cart: no requests at all. */
    if (!signature) { lastSignature = null; return Promise.resolve(); }
    if (signature === lastSignature) return Promise.resolve();

    running = true;
    writesThisPass = 0;
    var desired = desiredByVariant();
    var retried = false;

    function attempt() {
      return getCart().then(function (cart) {
        return applyPlan(cart, desired, MAX_LINES);
      });
    }

    return enqueue(function () {
      return withTimeout(
        attempt().catch(function (err) {
          /* Another tab moved the cart on, so our line keys are stale. Re-read
             and try once more, then give up quietly. */
          if (!retried && (err.status === 404 || err.status === 422)) {
            retried = true;
            return attempt();
          }
          throw err;
        })
      );
    }).then(function (result) {
      running = false;
      if (result && result.__error) {
        debug('reconciliation abandoned', result.__error);
        return;
      }
      /* Only remember the signature after a clean pass, so a failed one is
         retried on the next cart render rather than being cached as done. */
      lastSignature = signature;
      /* Only ask the cart to rebuild when something actually changed. A
         rebuild replaces the markup, which schedules another pass, so firing
         it on a no-op pass would cost a needless round trip every time. */
      if (writesThisPass) refreshCartMarkup();
    }, function (err) {
      running = false;
      debug('reconciliation abandoned', err);
    });
  }

  /* Impulse rebuilds the cart markup from /cart?view=ajax. Asking it to
     rebuild is how the changed properties become visible without this block
     knowing anything about the drawer's internals. */
  function refreshCartMarkup() {
    try {
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (e) { /* nothing to refresh */ }
  }

  /* Runs after paint, never before it. The drawer opens first and the cart
     updates afterwards. */
  function schedule() {
    window.setTimeout(function () { pass(); }, 0);
  }

  /* ---------- triggers ---------------------------------------------------- */

  function start() {
    wrapThemeCart();

    document.addEventListener('drawerOpen', schedule);
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('ajaxProduct:added', schedule);

    /* Mirror when the customer changes their postcode, and again the moment a
       cart first exists to hold it. Both paths no-op when the value is already
       on the cart, so neither costs a write. */
    D.onChange(mirrorPostcode);
    document.addEventListener('ajaxProduct:added', mirrorPostcode);
    window.setTimeout(mirrorPostcode, 0);

    /* A restored page can be minutes or hours stale, so the availability it
       shows cannot be trusted. */
    window.addEventListener('pageshow', function (evt) {
      if (evt && evt.persisted) { lastSignature = null; schedule(); }
    });

    /* The cart markup is replaced wholesale after every change. Watching for
       that is more reliable than any single event, and re-entrancy is held
       off by the running flag and the signature check. */
    if (window.MutationObserver) {
      var containers = document.querySelectorAll('[data-products]');
      for (var i = 0; i < containers.length; i++) {
        new MutationObserver(schedule).observe(containers[i], { childList: true, subtree: true });
      }
    }

    schedule();
  }

  /* Public entry to the shared queue for other TSS modules that write to the
     cart, so every write in the theme still passes through this one chain
     with the same release valve. Resolves with the task's value, with null
     when the valve trips, or with { __error } when the task fails. Never
     rejects. Promise.resolve().then(task) turns a task that throws
     synchronously into a rejection the valve can catch, rather than an
     exception thrown into the queue. */
  D.cartWrite = function (task) {
    return enqueue(function () {
      return withTimeout(Promise.resolve().then(task));
    });
  };

  /* Exposed for tests and for manual use from the console. */
  D._reconcile = pass;
  D._mirrorPostcode = mirrorPostcode;
  D._reconcileInternals = {
    nextProps: nextProps,
    mirrorPostcode: mirrorPostcode,
    planFor: planFor,
    enqueue: enqueue,
    wrapThemeCart: wrapThemeCart,
    reset: function () { running = false; lastSignature = null; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(window, document);
/* TSS-DELIVERY-RECON-END */

/* ==========================================================================
   Stage Shop — cart drawer page scroll lock on touch devices
   Not part of the free shipping bar: it runs whether that is on or off.

   Impulse locks the page behind an open drawer with overflow: hidden on
   <html> (theme.css .js-drawer-open, and .supports-touch.lock-scroll from
   theme.a11y.lockMobileScrolling, theme.js:237). iOS Safari ignores
   overflow: hidden on the root for touch scrolling, and Impulse even resets
   lock-scroll to overflow: initial there (theme.css:3024). So a swipe that
   starts on the drawer's header or footer, which do not scroll themselves,
   scrolls the page behind the drawer.

   On touch devices only, and only for #CartDrawer, this pins the page with
   the position-fixed body technique while the cart drawer is open: store
   scrollY, fix the body at top: -scrollY, and on close put everything back
   and scroll to exactly where the customer was. Desktop keeps Impulse's own
   lock, unchanged.

   It follows the drawer's own open class, so every way of closing it (the X,
   a tap outside, Escape, a quick view opening) unlocks the page, and it
   re-checks on pageshow so a page restored from the back-forward cache is
   never left pinned. It never uses touch-action and never blocks a touch,
   so every control in the drawer keeps working, and a drawer taller than
   the screen still scrolls (Impulse makes .drawer overflow: scroll below
   400px of height).
   ========================================================================== */
/* TSS-DRAWER-LOCK-START */
(function (window, document) {
  'use strict';

  var drawer = document.getElementById('CartDrawer');
  if (!drawer || !window.matchMedia || !window.MutationObserver) return;

  var touch = window.matchMedia('(hover: none) and (pointer: coarse)');
  var OPEN = 'drawer--is-open';
  var PROPS = ['position', 'top', 'left', 'right', 'width'];
  var locked = false;
  var savedY = 0;
  var savedStyle = null;

  function lock() {
    if (locked || !touch.matches) return;
    var style = document.body.style;
    savedY = window.scrollY || window.pageYOffset || 0;
    savedStyle = {};
    PROPS.forEach(function (p) { savedStyle[p] = style[p]; });
    style.position = 'fixed';
    style.top = (-savedY) + 'px';
    style.left = '0';
    style.right = '0';
    style.width = '100%';
    locked = true;
  }

  function unlock() {
    if (!locked) return;
    var style = document.body.style;
    PROPS.forEach(function (p) { style[p] = savedStyle[p]; });
    locked = false;
    /* Back to the same place, instantly: a smooth scroll-behavior here
       would animate from the top of the page. */
    var root = document.documentElement;
    var behaviour = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedY);
    root.style.scrollBehavior = behaviour;
  }

  function sync() {
    try {
      if (drawer.classList.contains(OPEN) && touch.matches) lock();
      else unlock();
    } catch (e) {
      /* Never leave the page pinned because of an error. */
      try { unlock(); } catch (e2) { /* nothing more to do */ }
    }
  }

  new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('pageshow', sync);
  if (typeof touch.addEventListener === 'function') touch.addEventListener('change', sync);
  sync();
})(window, document);
/* TSS-DRAWER-LOCK-END */

/* ==========================================================================
   Stage Shop — free shipping progress bar and gap-closing add-ons
   Spec: docs/specs/tss-free-shipping-bar.md

   Isolation. This is its own module. It reads the cart from the markup
   Impulse already renders (the ajax view's subtotal and each line's data
   attributes), writes to the cart only through TSSDelivery.cartWrite, the
   theme's one shared write queue, and asks Impulse to rebuild with
   cart:build, the same event the availability reconciliation uses. It wraps,
   patches and replaces nothing. The only Impulse function it calls is the
   money formatter, and that call is guarded.

   Fail closed. Every entry point runs through guard(). Any error hides the
   bar and the row, warns once, and stops this module for the rest of the
   page. Nothing here can throw into Impulse's or the estimator's code.

   Loop safety. The bar and the row live outside [data-products], so nothing
   written here can wake the observer that watches it, and a render is
   skipped outright when the cart's signature has not changed.
   ========================================================================== */
/* TSS-FSB-START */
(function (window, document) {
  'use strict';

  /* The kill switch. With the feature off the config tag is not rendered,
     and nothing below this line runs. */
  var configEl = document.getElementById('TssFsbConfig');
  if (!configEl || configEl.tssFsbInit) return;
  configEl.tssFsbInit = true;

  var SOURCE_KEY = '_tss_source';
  var SOURCE_VALUE = 'fsb';
  var ADDED_HOLD_MS = 1500;
  /* Fade (200ms), then collapse (250ms, starting at 150ms). Matches the
     transition on .tss-fsb-item in custom.css. */
  var LEAVE_MS = 420;
  var CELEBRATE_MS = 800;
  /* Pickers inside the drawer sit inside Impulse's checkout form. Pointing
     their form attribute at an id that does not exist detaches them, so the
     checkout submit never posts them. */
  var NO_FORM = 'TssFsbNoForm';
  /* An untracked variant can always ship, so it outranks any real count
     when two add-ons tie on price. */
  var UNTRACKED_STOCK = 1000000;

  var cfg = null;
  var pool = [];
  var dead = false;
  var surfaces = {};
  var order = [];
  var selections = {};
  var soldOut = {};
  var pending = {};
  var holding = 0;
  var stateSent = false;
  var warnedNoQueue = false;

  /* ---------- fail closed ------------------------------------------------- */

  function stop(err) {
    if (dead) return;
    dead = true;
    try {
      var els = document.querySelectorAll('[data-tss-fsb-bar], [data-tss-fsb-row]');
      for (var i = 0; i < els.length; i++) els[i].hidden = true;
    } catch (e) { /* nothing more can be done */ }
    try {
      if (window.console && console.warn) {
        console.warn('TSS free shipping bar stopped after an error. The cart itself is unaffected.', err);
      }
    } catch (e) { /* console unavailable */ }
  }

  function guard(fn) {
    return function () {
      if (dead) return undefined;
      try {
        return fn.apply(this, arguments);
      } catch (err) {
        stop(err);
        return undefined;
      }
    };
  }

  /* ---------- small helpers ----------------------------------------------- */

  function has(o, k) { return Object.prototype.hasOwnProperty.call(o, k); }
  function lower(s) { return String(s == null ? '' : s).replace(/^\s+|\s+$/g, '').toLowerCase(); }
  function num(v, fallback) { v = Number(v); return isFinite(v) ? v : fallback; }
  function squash(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').replace(/^\s+|\s+$/g, ''); }

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function reducedMotion() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) {
      return false;
    }
  }

  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!has(attrs, k)) continue;
        var v = attrs[k];
        if (v == null || v === false) continue;
        if (k === 'text') el.textContent = v;
        else if (k === 'className') el.className = v;
        else el.setAttribute(k, v === true ? '' : String(v));
      }
    }
    if (kids) {
      for (var i = 0; i < kids.length; i++) {
        if (kids[i] == null) continue;
        el.appendChild(typeof kids[i] === 'string' ? document.createTextNode(kids[i]) : kids[i]);
      }
    }
    return el;
  }

  /* ---------- config ------------------------------------------------------ */

  function readConfig(raw) {
    var up = raw.upsell || {};
    var msg = raw.msg || {};
    return {
      threshold: Math.round(num(raw.threshold, 10000)),
      minSubtotal: Math.round(num(raw.minSubtotal, 0)),
      showWhenEmpty: raw.showWhenEmpty === true,
      excludeTag: lower(raw.excludeTag),
      excludedBehaviour: raw.excludedBehaviour === 'hide' ? 'hide' : 'note',
      celebrate: raw.celebrate === true,
      msg: {
        empty: msg.empty || '',
        progress: msg.progress || '',
        unlocked: msg.unlocked || '',
        unlockedSub: squash(msg.unlockedSub),
        heading: msg.heading || '',
        headingUnlocked: msg.headingUnlocked || msg.heading || '',
        add: msg.add || 'Add',
        adding: msg.adding || 'Adding',
        added: msg.added || 'Added',
        soldOut: msg.soldOut || '',
        error: msg.error || '',
        sizeGuide: msg.sizeGuide || '',
        regularPrice: msg.regularPrice || '',
        salePrice: msg.salePrice || ''
      },
      upsell: {
        enabled: up.enabled === true,
        countDrawer: Math.max(1, num(up.countDrawer, 6)),
        countPage: Math.max(1, num(up.countPage, 6)),
        maxGap: num(up.maxGap, 6000),
        overshootCap: num(up.overshootCap, 3000),
        minPrice: num(up.minPrice, 500),
        minResults: Math.max(1, num(up.minResults, 1)),
        allowBackorder: up.allowBackorder === true,
        afterUnlock: up.afterUnlock === 'keep' ? 'keep' : 'hide',
        showSizeGuide: up.showSizeGuide === true,
        showVendor: up.showVendor === true
      }
    };
  }

  function readPool(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.filter(function (p) {
      return p && p.id && Array.isArray(p.variants) && Array.isArray(p.options);
    });
  }

  /* ---------- money --------------------------------------------------------
     The shop's own format through Impulse's formatter, with whole dollars
     shown without cents, matching Liquid's money_without_trailing_zeros on
     the first paint: $18, $18.50, $100. */

  function money(cents) {
    cents = Math.max(0, Math.round(num(cents, 0)));
    var whole = cents % 100 === 0;
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    if (whole) {
      fmt = fmt
        .replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}')
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}');
    }
    var out = null;
    try {
      if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
        out = window.theme.Currency.formatMoney(cents, fmt);
      }
    } catch (e) {
      out = null;
    }
    if (typeof out !== 'string' || !out) {
      out = '$' + (whole ? String(cents / 100) : (cents / 100).toFixed(2));
    }
    /* The formatter can wrap cents in <sup>. Text only here. */
    return out.replace(/<[^>]*>/g, '');
  }

  /* ---------- messages ---------------------------------------------------- */

  var TOKEN = /(\[gap\]|\[threshold\]|\[subtotal\])/;

  function tokensFor(cart) {
    return {
      '[gap]': money(Math.max(cfg.threshold - cart.total, 0)),
      '[threshold]': money(cfg.threshold),
      '[subtotal]': money(cart.total)
    };
  }

  function plainMessage(template, tokens) {
    return String(template || '').split(TOKEN).map(function (part) {
      return has(tokens, part) ? tokens[part] : part;
    }).join('');
  }

  /* Built from text nodes, so a merchant's message can never inject markup.
     The gap amount is the one figure set in <strong>. */
  function paintMessage(el, template, tokens) {
    while (el.firstChild) el.removeChild(el.firstChild);
    String(template || '').split(TOKEN).forEach(function (part) {
      if (!part) return;
      if (part === '[gap]') el.appendChild(h('strong', { text: tokens[part] }));
      else el.appendChild(document.createTextNode(has(tokens, part) ? tokens[part] : part));
    });
  }

  /* ---------- the cart, as the markup says it is ---------------------------
     After Impulse's first rebuild, [data-products] holds the ajax view's
     .cart__items wrapper, which carries the count and the subtotal after
     discounts, and each line carries our product id and separate-rate flag.
     Before that (the drawer before its first build, the cart page before any
     change) the Liquid snapshot on the bar is the same cart. */

  function formFor(name) {
    return document.getElementById(name === 'page' ? 'CartPageForm' : 'CartDrawerForm');
  }

  function readCart(s) {
    var form = formFor(s.name);
    var products = form && form.querySelector('[data-products]');
    var wrap = products && products.querySelector('.cart__items[data-cart-subtotal]');
    var ids = {};
    var separate = false;
    var total, count, keys = [];

    if (wrap) {
      total = Math.round(num(wrap.getAttribute('data-cart-subtotal'), 0));
      count = Math.round(num(wrap.getAttribute('data-count'), 0));
      var lines = wrap.querySelectorAll('[data-tss-fsb-product-id]');
      for (var i = 0; i < lines.length; i++) {
        ids[lines[i].getAttribute('data-tss-fsb-product-id')] = true;
        keys.push(lines[i].getAttribute('data-key') || '');
        if (lines[i].getAttribute('data-tss-fsb-separate-rate') === 'true') separate = true;
      }
      return { total: total, count: count, ids: ids, separate: separate,
               sig: 'm|' + count + '|' + total + '|' + keys.join(',') };
    }

    var bar = s.bar;
    total = Math.round(num(bar.getAttribute('data-tss-fsb-subtotal'), 0));
    count = Math.round(num(bar.getAttribute('data-tss-fsb-count'), 0));
    String(bar.getAttribute('data-tss-fsb-ids') || '').split(',').forEach(function (id) {
      if (id) ids[id] = true;
    });
    separate = bar.getAttribute('data-tss-fsb-separate') === 'true';
    return { total: total, count: count, ids: ids, separate: separate,
             sig: 's|' + count + '|' + total + '|' + bar.getAttribute('data-tss-fsb-ids') };
  }

  /* ---------- states (spec 6.2) ------------------------------------------- */

  function stateFor(cart) {
    if (!cart.count) return 'empty';
    if (cart.separate && cfg.excludedBehaviour === 'hide') return 'hidden';
    if (cart.total < cfg.minSubtotal) return 'hidden';
    return cart.total >= cfg.threshold ? 'unlocked' : 'progress';
  }

  /* ---------- eligibility (spec 7.1) --------------------------------------
     Pure, apart from the local sold-out list. Filters in the spec's order. */

  function shipsNow(v) {
    if (soldOut[v.id]) return false;
    if (!v.managed || v.qty > 0) return true;
    return cfg.upsell.allowBackorder && v.policy === 'continue';
  }

  function eligible(products, inCart, gap) {
    var up = cfg.upsell;
    var out = [];
    products.forEach(function (p) {
      /* 1. Bloch never shows. Hard-coded, repeating the Liquid rule. */
      if (/bloch/i.test(p.vendor || '')) return;
      /* 2. Nothing already in the bag, in any variant. */
      if (inCart[String(p.id)]) return;
      /* 3. Nothing that ships on its own rate. */
      if (cfg.excludeTag && (p.tags || []).some(function (t) { return lower(t) === cfg.excludeTag; })) return;
      /* Any option names, any number of options: every product in the
         collection is eligible on its options. 4 to 6 were removed. */
      /* 7 and 8. Only what ships now, so an add-on never delays the order. */
      var vs = p.variants.filter(shipsNow);
      if (!vs.length) return;
      var price = Math.min.apply(Math, vs.map(function (v) { return v.price; }));
      /* 9 and 10. Price floor, and the overshoot cap. */
      if (price < up.minPrice) return;
      if (price > gap + up.overshootCap) return;
      var stock = vs.reduce(function (n, v) {
        return n + (v.managed ? Math.max(v.qty, 0) : UNTRACKED_STOCK);
      }, 0);
      out.push({ p: p, variants: vs, price: price, stock: stock });
    });
    return out;
  }

  /* The pinned products (settings tss_fsb_pinned_1 to 3) that can be offered
     to this cart, in their setting order. Filters 1, 2, 3, 7 and 8 above; the
     price rules (9 and 10) do not apply to them. */
  function pinnedEligible(products, inCart) {
    var out = [];
    products.forEach(function (p) {
      var slot = Math.round(num(p.pinned, 0));
      if (slot < 1) return;
      if (/bloch/i.test(p.vendor || '')) return;
      if (inCart[String(p.id)]) return;
      if (cfg.excludeTag && (p.tags || []).some(function (t) { return lower(t) === cfg.excludeTag; })) return;
      var vs = p.variants.filter(shipsNow);
      if (!vs.length) return;
      var price = Math.min.apply(Math, vs.map(function (v) { return v.price; }));
      out.push({ p: p, variants: vs, price: price, stock: 0, slot: slot });
    });
    return out.sort(function (a, b) { return (a.slot - b.slot) || (a.p.id - b.p.id); });
  }

  /* ---------- ranking (spec 7.2): price only ------------------------------
     Closers first, the one that lands just over the threshold at the top.
     Steppers fill any slots left, closest to the gap first. Ties go to the
     item least likely to sell out before the add lands, then product id. */

  function rank(cands, gap) {
    function tie(a, b) { return (b.stock - a.stock) || (a.p.id - b.p.id); }
    var closers = cands.filter(function (c) { return c.price >= gap; })
      .sort(function (a, b) { return ((a.price - gap) - (b.price - gap)) || tie(a, b); });
    var steppers = cands.filter(function (c) { return c.price < gap; })
      .sort(function (a, b) { return ((gap - a.price) - (gap - b.price)) || tie(a, b); });
    return closers.concat(steppers);
  }

  /* ---------- options and variants -----------------------------------------
     Every product in the collection is eligible whatever its options are
     called or however many it has. Preselection is name-agnostic apart from
     one word, applied in this order:

       a) An option with only one value among the product's ship-now variants
          is chosen for the customer and shown as plain text.
       b) An option whose name contains "size" is never preselected: a
          wrong-size default is a return.
       c) Otherwise the first option is preselected to its first value that
          can ship. Every other option is the customer's to choose.
       d) Each dropdown lists only the values that ship given the options
          before it, and changing an option clears any later choice that no
          longer ships with it.

     (a) looks at the whole product, not at the other choices, so picking a
     colour can never quietly pick the only size left in it.

     (d) runs in option order rather than against every other choice. Against
     every choice, a chosen size would hide the colours without it, and with
     no way to unpick a size the customer could never reach those colours. In
     order, the first option can always be changed, and no list ever shows a
     combination that cannot ship. */

  function isSizeName(opt) {
    return /size/i.test(String(opt && opt.name || ''));
  }

  /* The option's values that some ship-now variant has, in product order. */
  function shipValues(cand, idx) {
    return (cand.p.options[idx].values || []).filter(function (val) {
      return cand.variants.some(function (v) { return v.options[idx] === val; });
    });
  }

  function isFixed(cand, idx) {
    return shipValues(cand, idx).length === 1;
  }

  function isPreset(cand, idx) {
    return idx === 0 && !isFixed(cand, 0) && !isSizeName(cand.p.options[0]);
  }

  function isRequired(cand, idx) {
    return !isFixed(cand, idx) && !isPreset(cand, idx);
  }

  function offeredValues(cand, sel, idx) {
    return (cand.p.options[idx].values || []).filter(function (val) {
      return cand.variants.some(function (v) {
        if (v.options[idx] !== val) return false;
        for (var j = 0; j < idx; j++) {
          if (sel[j] != null && v.options[j] !== sel[j]) return false;
        }
        return true;
      });
    });
  }

  /* In option order: a fixed option takes its only value, a choice that no
     longer ships with the options before it is cleared, and the preset first
     option takes its first value that ships. */
  function normaliseSelection(cand, sel) {
    for (var idx = 0; idx < cand.p.options.length; idx++) {
      if (isFixed(cand, idx)) { sel[idx] = shipValues(cand, idx)[0]; continue; }
      var offered = offeredValues(cand, sel, idx);
      if (sel[idx] != null && offered.indexOf(sel[idx]) === -1) sel[idx] = null;
      if (sel[idx] == null && isPreset(cand, idx) && offered.length) sel[idx] = offered[0];
    }
    return sel;
  }

  function selectionFor(s, cand) {
    var key = s.name + ':' + cand.p.id;
    if (!selections[key]) selections[key] = {};
    return normaliseSelection(cand, selections[key]);
  }

  function resolveVariant(cand, sel) {
    var opts = cand.p.options;
    if (!opts.length) return cand.variants[0] || null;
    for (var i = 0; i < opts.length; i++) if (sel[i] == null) return null;
    for (var k = 0; k < cand.variants.length; k++) {
      var v = cand.variants[k], all = true;
      for (var j = 0; j < opts.length; j++) if (v.options[j] !== sel[j]) { all = false; break; }
      if (all) return v;
    }
    return null;
  }

  /* The picture follows the chosen colour where a variant has its own. */
  function imageFor(cand, sel) {
    for (var k = 0; k < cand.variants.length; k++) {
      var v = cand.variants[k];
      if (!v.image) continue;
      var match = true;
      for (var j = 0; j < cand.p.options.length; j++) {
        if (sel[j] != null && v.options[j] !== sel[j]) { match = false; break; }
      }
      if (match) return { src: v.image, srcset: null };
    }
    if (!cand.p.image) return null;
    return { src: cand.p.image, srcset: cand.p.image + ' 160w, ' + cand.p.image2x + ' 320w' };
  }

  /* How each option shows on the card: a fixed option is plain text,
     anything else a dropdown, starting on the option's own name when the
     customer must choose. Pure, for the tests. */
  function controlFor(cand, sel, idx) {
    if (isFixed(cand, idx)) return { kind: 'text', value: shipValues(cand, idx)[0] || '' };
    return { kind: 'select', offered: offeredValues(cand, sel, idx), placeholder: isRequired(cand, idx) };
  }

  /* The Add button's label while an option is still to be chosen, derived
     from the option itself: "Choose a size", "Choose a length", "Choose an
     edition". With several unchosen, the first in option order. It is also
     the button's accessible name, since the button has no other text then. */
  function chooseLabel(cand, sel) {
    var opts = cand.p.options;
    for (var i = 0; i < opts.length; i++) {
      if (sel[i] != null) continue;
      var name = String(opts[i].name || '').replace(/^\s+|\s+$/g, '').toLowerCase();
      return 'Choose ' + (/^[aeiou]/.test(name) ? 'an ' : 'a ') + name;
    }
    return 'Choose';
  }

  /* ---------- the size chart modal -----------------------------------------
     The chart opens in Impulse's own <tool-tip> modal, the one the product
     page's size chart uses (snippets/tool-tip.liquid, theme.js ToolTip): we
     dispatch its tooltip:open event with the chart's HTML, taken from the
     inert <template> the pool snippet renders once per chart. The chart's
     scripts initialise in the modal by themselves: the CM/IN toggle is
     delegated, and sc-lookup's observer binds the copy it sees added.

     Over the open cart drawer the tool-tip (z-index 10001) already stacks
     above the drawer (30). Three things need care, none of them in Impulse:
       - Escape: the tool-tip closes on keydown, but the drawer closes on the
         keyup of the same key, so that keyup is stopped.
       - Clicks inside the tool-tip (its overlay, its close button) would
         reach the drawer's outside-click handler on window and close it, so
         they stop at document while the drawer is open.
       - Closing the tool-tip removes Impulse's lock-scroll class from <html>
         although the drawer still needs it; it goes back on.
     On close, focus returns to the link that opened the chart. */

  var chartLink = null;
  var escapeFromChart = false;

  function chartTemplate(id) {
    return document.querySelector('template[data-tss-fsb-chart="' + id + '"]');
  }

  function toolTipEl() { return document.querySelector('tool-tip'); }

  function toolTipIsOpen() {
    var tip = toolTipEl();
    return !!(tip && tip.getAttribute('data-tool-tip-open') === 'true');
  }

  function cartDrawerIsOpen() {
    var d = document.getElementById('CartDrawer');
    return !!(d && d.classList.contains('drawer--is-open'));
  }

  function openChart(link) {
    var tpl = chartTemplate(link.getAttribute('data-tss-fsb-chart'));
    var tip = toolTipEl();
    if (!tpl || !tip) return false;
    chartLink = link;
    var watcher = new MutationObserver(guard(function () {
      if (toolTipIsOpen()) return;
      watcher.disconnect();
      if (cartDrawerIsOpen()) document.documentElement.classList.add('lock-scroll');
      var back = chartLink;
      chartLink = null;
      /* After the closing event has finished: Impulse's search also listens
         for Escape on document and blurs whatever has focus, so focusing
         here and now would be undone a moment later. */
      window.setTimeout(guard(function () {
        if (back && document.contains(back)) back.focus();
      }), 0);
    }));
    watcher.observe(tip, { attributes: true, attributeFilter: ['data-tool-tip-open'] });
    link.dispatchEvent(new CustomEvent('tooltip:open', {
      bubbles: true,
      detail: { context: 'size-chart', content: tpl.innerHTML }
    }));
    return true;
  }

  function guardDrawerFromChart() {
    document.addEventListener('keydown', guard(function (evt) {
      if ((evt.key === 'Escape' || evt.keyCode === 27) && toolTipIsOpen() && cartDrawerIsOpen()) {
        escapeFromChart = true;
      }
    }), true);
    window.addEventListener('keyup', guard(function (evt) {
      if (escapeFromChart && (evt.key === 'Escape' || evt.keyCode === 27)) {
        escapeFromChart = false;
        evt.stopPropagation();
      }
    }), true);
    document.addEventListener('click', guard(function (evt) {
      var t = evt.target;
      if (t && t.closest && t.closest('tool-tip') && cartDrawerIsOpen()) evt.stopPropagation();
    }));
  }

  /* ---------- rendering an add-on ----------------------------------------- */

  function idFor(s, cand, idx) {
    return 'TssFsb-' + s.name + '-' + cand.p.id + '-' + idx;
  }

  function renderOption(s, cand, sel, idx, control) {
    var opt = cand.p.options[idx];
    /* "Colour: Nude", as the product page labels an option: the name in the
       label style, the value as the label's info (variant-button.liquid). */
    if (control.kind === 'text') {
      return h('p', { className: 'tss-fsb-item__value' }, [
        h('span', { className: 'tss-fsb-item__value-name', text: opt.name + ':' }),
        ' ',
        h('span', { className: 'tss-fsb-item__value-text', text: control.value })
      ]);
    }
    var selectId = idFor(s, cand, idx);
    var select = h('select', {
      id: selectId, className: 'tss-fsb-select', form: NO_FORM, 'data-tss-fsb-opt': idx
    });
    /* A size starts on its own name, which cannot be chosen back. */
    if (control.placeholder) {
      select.appendChild(h('option', { value: '', text: opt.name, disabled: true, selected: sel[idx] == null }));
    }
    control.offered.forEach(function (val) {
      select.appendChild(h('option', { value: val, text: val, selected: sel[idx] === val }));
    });
    return h('div', { className: 'tss-fsb-item__opt' }, [
      h('label', { className: 'tss-fsb-sr', 'for': selectId, text: opt.name }),
      select
    ]);
  }

  /* The price of the variant shown: the chosen one, or while a choice is
     still to be made, the cheapest that ships (the price the ranking used).
     On sale, the same pattern as the collection tiles
     (snippets/product-grid-item.liquid): the compare-at price first, struck
     through, then the current price in the theme's savings colour. */
  function shownVariant(cand, variant) {
    if (variant) return variant;
    for (var i = 0; i < cand.variants.length; i++) {
      if (cand.variants[i].price === cand.price) return cand.variants[i];
    }
    return cand.variants[0] || null;
  }

  function renderPrice(cand, variant) {
    var v = shownVariant(cand, variant);
    var price = v ? v.price : cand.price;
    var compare = v ? num(v.compare, 0) : 0;
    if (!(compare > price)) {
      return h('span', { className: 'tss-fsb-item__price', text: money(price) });
    }
    return h('span', { className: 'tss-fsb-item__price' }, [
      cfg.msg.regularPrice ? h('span', { className: 'tss-fsb-sr', text: cfg.msg.regularPrice + ' ' }) : null,
      h('s', { className: 'tss-fsb-item__was', text: money(compare) }),
      cfg.msg.salePrice ? h('span', { className: 'tss-fsb-sr', text: ' ' + cfg.msg.salePrice + ' ' }) : null,
      h('span', { className: 'tss-fsb-item__now', 'data-tss-fsb-sale': true, text: money(price) })
    ]);
  }

  function renderItem(s, cand, message) {
    var p = cand.p;
    var sel = selectionFor(s, cand);
    var variant = resolveVariant(cand, sel);
    var opts = h('div', { className: 'tss-fsb-item__opts' });
    p.options.forEach(function (o, idx) {
      var control = controlFor(cand, sel, idx);
      if (control.kind === 'text' && !control.value) return;
      opts.appendChild(renderOption(s, cand, sel, idx, control));
    });
    /* "Size guide" only when the product has a size chart, the same chart the
       product page shows. It opens in the theme's own modal; the href to the
       product page is the fallback if that cannot happen. It shares the
       price's line, so a card is no taller for having one. */
    var guide = p.sizeChart && chartTemplate(p.sizeChart) && cfg.upsell.showSizeGuide && cfg.msg.sizeGuide
      ? h('a', {
          className: 'tss-fsb-item__guide',
          href: p.url,
          'data-tss-fsb-chart': p.sizeChart,
          'aria-haspopup': 'dialog',
          text: cfg.msg.sizeGuide
        })
      : null;

    var img = imageFor(cand, sel);
    var media = h('a', { className: 'tss-fsb-item__media', href: p.url, tabindex: '-1', 'aria-hidden': 'true' });
    if (img) {
      media.appendChild(h('img', {
        src: img.src,
        srcset: img.srcset,
        sizes: s.name === 'page' ? '170px' : '150px',
        width: 160,
        height: Math.round(160 / (num(p.imageRatio, 1) || 1)),
        loading: 'lazy',
        alt: ''
      }));
    }

    var info = h('div', { className: 'tss-fsb-item__info' }, [
      h('a', { className: 'tss-fsb-item__title', href: p.url, title: p.title, text: p.title }),
      cfg.upsell.showVendor && p.vendor ? h('span', { className: 'tss-fsb-item__vendor', text: p.vendor }) : null,
      h('div', { className: 'tss-fsb-item__meta' }, [
        renderPrice(cand, variant),
        guide
      ])
    ]);

    var busy = !!pending[p.id];
    var button = h('button', {
      type: 'button',
      className: 'tss-fsb-item__add',
      'data-tss-fsb-add': true,
      disabled: !variant || busy
    });
    if (variant) {
      var chosen = variant.options.filter(function (o) { return o && o !== 'Default Title'; });
      button.appendChild(document.createTextNode(cfg.msg.add));
      button.appendChild(h('span', { className: 'tss-fsb-sr', text: ' ' + [p.title].concat(chosen).join(', ') }));
    } else {
      button.appendChild(document.createTextNode(chooseLabel(cand, sel)));
      /* The longer "Choose a ..." label tightens its tracking to stay on one
         line; the font size never drops. */
      button.setAttribute('data-tss-fsb-choose', '');
    }

    return h('li', {
      className: 'tss-fsb-item',
      'data-tss-fsb-item': true,
      'data-tss-fsb-pid': p.id
    }, [
      media,
      info,
      opts.firstChild ? opts : null,
      button,
      h('p', { className: 'tss-fsb-item__msg', 'data-tss-fsb-msg': true, text: message || '' })
    ]);
  }

  /* Replacing an item keeps keyboard focus on the same control. */
  function replaceItem(s, cand, oldEl, focusId, message) {
    var fresh = renderItem(s, cand, message);
    oldEl.parentNode.replaceChild(fresh, oldEl);
    if (focusId) {
      var again = document.getElementById(focusId);
      if (again && fresh.contains(again)) again.focus();
    }
    return fresh;
  }

  function announce(s, text) {
    if (!s.live) return;
    s.live.textContent = '';
    window.setTimeout(guard(function () { s.live.textContent = text; }), 50);
  }

  /* ---------- rendering the bar ------------------------------------------- */

  function renderBar(s, cart, state) {
    var bar = s.bar;
    var visible = state === 'progress' || state === 'unlocked' || (state === 'empty' && cfg.showWhenEmpty);
    var previous = bar.getAttribute('data-tss-fsb-state');
    bar.setAttribute('data-tss-fsb-state', state);
    bar.hidden = !visible;
    if (!visible) return;

    var template = state === 'empty' ? cfg.msg.empty : (state === 'unlocked' ? cfg.msg.unlocked : cfg.msg.progress);
    var tokens = tokensFor(cart);
    var plain = plainMessage(template, tokens);

    /* Only touch the live region when the words change, so a screen reader
       is not told the same thing twice. */
    if (s.text && squash(s.text.textContent) !== squash(plain)) paintMessage(s.text, template, tokens);

    var icons = bar.querySelectorAll('[data-tss-fsb-icon]');
    for (var i = 0; i < icons.length; i++) {
      icons[i].hidden = icons[i].getAttribute('data-tss-fsb-icon') !== (state === 'unlocked' ? 'unlocked' : 'progress');
    }
    if (s.sub) s.sub.hidden = !(state === 'unlocked' && cfg.msg.unlockedSub);
    if (s.note) s.note.hidden = !(cart.separate && state !== 'empty');

    if (s.track) {
      s.track.setAttribute('aria-valuenow', String(Math.min(cart.total, cfg.threshold) / 100));
      s.track.setAttribute('aria-valuetext', plain);
    }
    if (s.fill) {
      s.fill.style.transform = 'scaleX(' + Math.max(0, Math.min(cart.total / cfg.threshold, 1)) + ')';
      if (previous === 'progress' && state === 'unlocked' && cfg.celebrate && !reducedMotion()) {
        s.fill.setAttribute('data-tss-fsb-celebrate', '');
        window.setTimeout(guard(function () { s.fill.removeAttribute('data-tss-fsb-celebrate'); }), CELEBRATE_MS);
      }
    }
  }

  /* ---------- rendering the row ------------------------------------------- */

  /* What the row should hold for this cart. Pure, so the worked examples in
     the spec can be tested directly. */
  /* Pinned products lead the row whenever they can be offered at all. Ranked
     products then fill the slots left. The gap and price rules only shape the
     ranked part:

       progress, gap within the max   pinned, then ranked
       progress, gap above the max    pinned only
       unlocked                       pinned only, under the unlocked heading,
                                      whatever after_unlock says
       unlocked, no pinned eligible   after_unlock as before

     A pinned product is never ranked as well, even when it is also in the
     add-on collection. */
  function plan(cart, state, count) {
    var up = cfg.upsell;
    var gap = Math.max(cfg.threshold - cart.total, 0);
    var heading = cfg.msg.heading;
    var none = { show: false, heading: heading, ranked: [] };

    if (!up.enabled || !pool.length) return none;
    if (state !== 'progress' && state !== 'unlocked') return none;

    var pinned = pinnedEligible(pool, cart.ids).slice(0, count);
    var rankFill = false;
    if (state === 'progress') {
      rankFill = gap <= up.maxGap;
    } else {
      heading = cfg.msg.headingUnlocked;
      rankFill = !pinned.length && up.afterUnlock === 'keep';
    }

    var ranked = [];
    if (rankFill && pinned.length < count) {
      var unpinned = pool.filter(function (p) { return !p.pinned; });
      ranked = rank(eligible(unpinned, cart.ids, gap), gap).slice(0, count - pinned.length);
    }

    /* Never a heading over an empty row. A pinned product is always enough. */
    if (!pinned.length && ranked.length < up.minResults) return none;
    return { show: true, heading: heading, ranked: pinned.concat(ranked) };
  }

  function renderRow(s, cart, state) {
    if (!s.row) return;
    /* While an add is in flight or showing "Added", the row holds still. It
       catches up the moment the hold ends. */
    if (holding > 0) { s.deferred = true; return; }
    s.deferred = false;

    var result = plan(cart, state, s.name === 'page' ? cfg.upsell.countPage : cfg.upsell.countDrawer);
    var show = result.show;
    var heading = result.heading;
    var ranked = result.ranked;

    if (!show) {
      s.row.hidden = true;
      s.renderedIds = '';
      s.cands = {};
      return;
    }

    if (s.heading && s.heading.textContent !== heading) s.heading.textContent = heading;

    var ids = ranked.map(function (c) { return c.p.id; }).join(',');
    s.cands = {};
    ranked.forEach(function (c) { s.cands[String(c.p.id)] = c; });

    if (ids !== s.renderedIds) {
      var active = document.activeElement;
      var hadFocus = !!(active && s.list.contains(active));
      var focusId = hadFocus ? active.id : null;

      while (s.list.firstChild) s.list.removeChild(s.list.firstChild);
      ranked.forEach(function (c) { s.list.appendChild(renderItem(s, c)); });
      s.renderedIds = ids;

      /* Keep focus where it was if that control survived, otherwise move it
         to the heading rather than dropping it on the page. */
      if (hadFocus) {
        var again = focusId && document.getElementById(focusId);
        if (again && s.list.contains(again)) again.focus();
        else if (s.heading) s.heading.focus();
      }
    }
    s.row.hidden = false;
    updateArrows(s);
  }

  /* ---------- the carousel ------------------------------------------------
     Native overflow scrolling does the work: momentum on touch, snapping in
     CSS. The arrows only exist for a mouse. Each moves by one card, and each
     is disabled at its end; both hide when every card already fits. */

  function updateArrows(s) {
    if (!s.scroller || !s.arrows) return;
    var el = s.scroller;
    var room = el.scrollWidth - el.clientWidth;
    s.arrows.hidden = !(room > 1);
    if (s.prev) s.prev.disabled = el.scrollLeft <= 1;
    if (s.next) s.next.disabled = el.scrollLeft >= room - 1;
  }

  function scrollByCard(s, direction) {
    if (!s.scroller) return;
    var card = s.list && s.list.querySelector('[data-tss-fsb-item]');
    var step = card ? card.getBoundingClientRect().width : 0;
    /* A card that cannot be measured still moves the row: by a view. */
    if (!step) step = s.scroller.clientWidth;
    var gap = 0;
    try { gap = parseFloat(window.getComputedStyle(s.list).columnGap) || 0; } catch (e) { gap = 0; }
    var left = direction * (step + gap);
    if (typeof s.scroller.scrollBy === 'function') {
      s.scroller.scrollBy({ left: left, behavior: reducedMotion() ? 'auto' : 'smooth' });
    } else {
      s.scroller.scrollLeft += left;
    }
  }

  /* ---------- the render pass --------------------------------------------- */

  function update(s, force) {
    var cart = readCart(s);
    if (!force && cart.sig === s.lastSig) return;
    s.lastSig = cart.sig;
    s.cart = cart;
    s.state = stateFor(cart);
    renderBar(s, cart, s.state);
    renderRow(s, cart, s.state);

    if (!stateSent && typeof window.clarity === 'function') {
      stateSent = true;
      try { window.clarity('set', 'tss_fsb_state', s.state); } catch (e) { /* analytics only */ }
    }
  }

  function schedule(s) {
    if (s.queued) return;
    s.queued = true;
    window.setTimeout(guard(function () { s.queued = false; update(s); }), 0);
  }

  /* An add holds every row still from the tap until its item has left, so
     the button being updated is never swapped out from under it. After a
     success every row re-renders, so the item that left is gone for good.
     After a failure only a row that missed a cart change catches up, so the
     message beside the item stays readable. */
  function releaseHold(all) {
    holding = Math.max(0, holding - 1);
    if (holding) return;
    order.forEach(function (name) {
      var s = surfaces[name];
      if (s.cart && (all || s.deferred)) {
        s.renderedIds = '';
        renderRow(s, s.cart, s.state);
      }
    });
  }

  /* ---------- adding (spec 9.3) ------------------------------------------- */

  function postAdd(variantId) {
    var routes = (window.theme && window.theme.routes) || {};
    var line = { id: variantId, quantity: 1, properties: {} };
    line.properties[SOURCE_KEY] = SOURCE_VALUE;
    return fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [line] })
    }).then(function (res) {
      return res.json().then(
        function (body) { return { ok: res.ok, status: res.status, body: body }; },
        function () { return { ok: res.ok, status: res.status, body: null }; }
      );
    });
  }

  /* Through the shared queue, so an add can never interleave with a
     quantity change or an availability write. Without the queue (it is
     always there in this file; this is belt and braces) the add still goes,
     once, with a warning. */
  function runAdd(variantId) {
    if (typeof window.TSSDelivery !== 'undefined' && window.TSSDelivery &&
        typeof window.TSSDelivery.cartWrite === 'function') {
      return window.TSSDelivery.cartWrite(function () { return postAdd(variantId); });
    }
    if (!warnedNoQueue) {
      warnedNoQueue = true;
      if (window.console && console.warn) console.warn('TSS free shipping bar: shared cart queue not found, adding without it.');
    }
    return postAdd(variantId).then(null, function (err) { return { __error: err }; });
  }

  /* After a timeout or a network failure the add may or may not have
     landed. One read of the cart decides, never an assumption. */
  function landed(variantId) {
    var routes = (window.theme && window.theme.routes) || {};
    return fetch(routes.cart || '/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        return !!(cart && cart.items && cart.items.some(function (item) {
          return item.variant_id === variantId && item.properties && item.properties[SOURCE_KEY] === SOURCE_VALUE;
        }));
      }, function () { return false; });
  }

  /* Impulse rebuilds every cart surface from /cart?view=ajax on this event:
     line items, subtotal, discounts and the header count. The drawer is
     already open, so nothing needs opening. */
  function rebuildCart() {
    try {
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (e) { /* the next cart change catches up */ }
  }

  function setButton(button, label, busy) {
    if (!button) return;
    while (button.firstChild) button.removeChild(button.firstChild);
    button.appendChild(document.createTextNode(label));
    if (busy) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  function add(s, cand, variant, itemEl, button) {
    var pid = cand.p.id;
    pending[pid] = true;
    holding++;
    /* Lock the width so Adding and Added do not reflow the row. */
    button.style.width = button.offsetWidth + 'px';
    button.disabled = true;
    setButton(button, cfg.msg.adding, true);
    var controls = itemEl.querySelectorAll('input, select');
    for (var i = 0; i < controls.length; i++) controls[i].disabled = true;
    var msgEl = itemEl.querySelector('[data-tss-fsb-msg]');
    if (msgEl) msgEl.textContent = '';

    function succeeded() {
      rebuildCart();
      setButton(button, cfg.msg.added, false);
      announce(s, cfg.msg.added + ' ' + cand.p.title);
      if (typeof window.clarity === 'function') {
        try { window.clarity('event', 'tss_fsb_add'); } catch (e) { /* analytics only */ }
      }
      window.setTimeout(guard(function () {
        var leave = reducedMotion() ? 0 : LEAVE_MS;
        itemEl.setAttribute('data-tss-fsb-leaving', '');
        window.setTimeout(guard(function () {
          delete pending[pid];
          releaseHold(true);
        }), leave);
      }), ADDED_HOLD_MS);
    }

    function failed(message) {
      delete pending[pid];
      button.style.width = '';
      if (itemEl.parentNode) {
        /* Re-render the item: a sold-out variant has left the pool, and the
           pickers must stop offering it. If nothing is left to offer, the
           old item stays with its button disabled until the next change. */
        var fresh = (cand.p.pinned ? pinnedEligible([cand.p], {}) : eligible([cand.p], {}, Infinity))[0];
        if (fresh) {
          s.cands[String(pid)] = fresh;
          replaceItem(s, fresh, itemEl, null, message);
        } else {
          setButton(button, cfg.msg.add, false);
          button.disabled = true;
          if (msgEl) msgEl.textContent = message;
        }
      }
      announce(s, message);
      releaseHold(false);
    }

    runAdd(variant.id).then(guard(function (result) {
      if (result && !result.__error && result.ok) { succeeded(); return; }

      if (result && !result.__error && result.status === 422) {
        var d = result.body && (result.body.description || result.body.message);
        if (/sold out/i.test(String(d || ''))) {
          soldOut[variant.id] = true;
          failed(cfg.msg.soldOut || cfg.msg.error);
          return;
        }
        failed(cfg.msg.error);
        return;
      }

      if (result && !result.__error) { failed(cfg.msg.error); return; }

      /* The valve tripped (null) or the request failed: re-read once and
         render from what the cart actually says. */
      landed(variant.id).then(guard(function (yes) {
        rebuildCart();
        if (yes) succeeded();
        else failed(cfg.msg.error);
      }));
    }));
  }

  /* ---------- events (document-level delegation) -------------------------- */

  function surfaceOf(el) {
    var row = el && el.closest ? el.closest('[data-tss-fsb-row]') : null;
    return row ? surfaces[row.getAttribute('data-tss-fsb-surface')] : null;
  }

  function onChange(evt) {
    var t = evt.target;
    if (!t || !t.getAttribute) return;
    var idx = t.getAttribute('data-tss-fsb-opt');
    if (idx === null) return;
    var s = surfaceOf(t);
    var itemEl = t.closest('[data-tss-fsb-item]');
    if (!s || !itemEl) return;
    var cand = s.cands && s.cands[itemEl.getAttribute('data-tss-fsb-pid')];
    if (!cand) return;

    var sel = selectionFor(s, cand);
    sel[parseInt(idx, 10)] = t.value === '' ? null : t.value;
    normaliseSelection(cand, sel);
    replaceItem(s, cand, itemEl, t.id);
  }

  function onClick(evt) {
    var chart = evt.target && evt.target.closest ? evt.target.closest('a[data-tss-fsb-chart]') : null;
    if (chart && surfaceOf(chart)) {
      if (openChart(chart)) evt.preventDefault();
      return;
    }
    var arrow = evt.target && evt.target.closest ? evt.target.closest('[data-tss-fsb-prev], [data-tss-fsb-next]') : null;
    if (arrow) {
      var row = surfaceOf(arrow);
      if (row && !arrow.disabled) scrollByCard(row, arrow.hasAttribute('data-tss-fsb-prev') ? -1 : 1);
      return;
    }
    var button = evt.target && evt.target.closest ? evt.target.closest('[data-tss-fsb-add]') : null;
    if (!button || button.disabled) return;
    var s = surfaceOf(button);
    var itemEl = button.closest('[data-tss-fsb-item]');
    if (!s || !itemEl) return;
    var cand = s.cands && s.cands[itemEl.getAttribute('data-tss-fsb-pid')];
    if (!cand || pending[cand.p.id]) return;
    var variant = resolveVariant(cand, selectionFor(s, cand));
    if (!variant) return;
    /* Never mutate a cart inside the theme editor. */
    if (designMode()) return;
    add(s, cand, variant, itemEl, button);
  }

  /* ---------- boot -------------------------------------------------------- */

  function bind(bar) {
    var name = bar.getAttribute('data-tss-fsb-surface');
    if (!name || surfaces[name] || bar.tssFsbBound) return;
    bar.tssFsbBound = true;

    var row = document.querySelector('[data-tss-fsb-row][data-tss-fsb-surface="' + name + '"]');
    var s = {
      name: name,
      bar: bar,
      text: bar.querySelector('[data-tss-fsb-text]'),
      sub: bar.querySelector('[data-tss-fsb-sub]'),
      note: bar.querySelector('[data-tss-fsb-note]'),
      track: bar.querySelector('[data-tss-fsb-track]'),
      fill: bar.querySelector('[data-tss-fsb-fill]'),
      row: row,
      list: row ? row.querySelector('[data-tss-fsb-list]') : null,
      heading: row ? row.querySelector('[data-tss-fsb-heading]') : null,
      scroller: row ? row.querySelector('[data-tss-fsb-scroller]') : null,
      arrows: row ? row.querySelector('[data-tss-fsb-arrows]') : null,
      prev: row ? row.querySelector('[data-tss-fsb-prev]') : null,
      next: row ? row.querySelector('[data-tss-fsb-next]') : null,
      live: null,
      cands: {},
      renderedIds: '',
      lastSig: null
    };
    if (row && !s.list) s.row = null;
    if (s.row) {
      s.live = h('p', { className: 'tss-fsb-sr', 'aria-live': 'polite' });
      s.row.appendChild(s.live);
    }
    /* Arrow state follows the scroll position and the track's width: the
       drawer changes width when it opens, and the page on resize. One
       update per frame at most. */
    if (s.scroller) {
      var framed = false;
      var onMove = guard(function () {
        if (framed) return;
        framed = true;
        (window.requestAnimationFrame || window.setTimeout)(guard(function () { framed = false; updateArrows(s); }));
      });
      s.scroller.addEventListener('scroll', onMove, { passive: true });
      if (window.ResizeObserver) new window.ResizeObserver(onMove).observe(s.scroller);
      else window.addEventListener('resize', onMove);
    }
    surfaces[name] = s;
    order.push(name);

    var form = formFor(name);
    var products = form && form.querySelector('[data-products]');
    if (products && window.MutationObserver) {
      new MutationObserver(guard(function () { schedule(s); }))
        .observe(products, { childList: true, subtree: true });
    }
    update(s, true);
  }

  var init = guard(function () {
    cfg = readConfig(JSON.parse(configEl.textContent));
    if (!(cfg.threshold > 0)) return;

    var poolEl = document.getElementById('TssFsbPool');
    pool = poolEl ? readPool(JSON.parse(poolEl.textContent)) : [];

    var bars = document.querySelectorAll('[data-tss-fsb-bar]');
    if (!bars.length) return;

    document.addEventListener('change', guard(onChange));
    document.addEventListener('click', guard(onClick));
    guardDrawerFromChart();
    for (var i = 0; i < bars.length; i++) bind(bars[i]);
  });

  /* For the test suite. Nothing else reads this. */
  window.TSSFsb = {
    _internals: {
      readConfig: readConfig,
      setConfig: function (c) { cfg = c; },
      setPool: function (p) { pool = readPool(p); },
      money: money,
      plainMessage: plainMessage,
      tokensFor: tokensFor,
      stateFor: stateFor,
      eligible: eligible,
      pinnedEligible: pinnedEligible,
      rank: rank,
      plan: plan,
      offeredValues: offeredValues,
      isFixed: isFixed,
      isPreset: isPreset,
      isRequired: isRequired,
      normaliseSelection: normaliseSelection,
      resolveVariant: resolveVariant,
      controlFor: controlFor,
      chooseLabel: chooseLabel,
      readCart: readCart,
      runAdd: runAdd,
      soldOut: soldOut,
      isDead: function () { return dead; },
      guard: guard
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
/* TSS-FSB-END */
